// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from '@hey-api/client-axios'
import type {
  ApiAioptimizeEffortEntryNotePostData,
  ApiAioptimizeEffortEntryNotePostResponse,
  ApiAioptimizeEffortEntryNotePostError,
  ApiActivitiesGetCollectionData,
  ApiActivitiesGetCollectionResponse,
  ApiActivitiesPostData,
  ApiActivitiesPostResponse,
  ApiActivitiesPostError,
  ApiActivitiesIdDeleteData,
  ApiActivitiesIdDeleteResponse,
  ApiActivitiesIdDeleteError,
  ApiActivitiesIdGetData,
  ApiActivitiesIdGetResponse,
  ApiActivitiesIdGetError,
  ApiActivitiesIdPutData,
  ApiActivitiesIdPutResponse,
  ApiActivitiesIdPutError,
  AdminUrlData,
  AdminUrlResponse,
  AdminUrlError,
  AdminUrlMultiData,
  AdminUrlMultiResponse,
  AdminUrlMultiError,
  ApiAnnouncementsGetCollectionData,
  ApiAnnouncementsGetCollectionResponse,
  ApiAnnouncementsPostData,
  ApiAnnouncementsPostResponse,
  ApiAnnouncementsPostError,
  ApiAnnouncementsIdDeleteData,
  ApiAnnouncementsIdDeleteResponse,
  ApiAnnouncementsIdDeleteError,
  ApiAnnouncementsIdGetData,
  ApiAnnouncementsIdGetResponse,
  ApiAnnouncementsIdGetError,
  ApiAnnouncementsIdPutData,
  ApiAnnouncementsIdPutResponse,
  ApiAnnouncementsIdPutError,
  ApiAttachmentsGetCollectionData,
  ApiAttachmentsGetCollectionResponse,
  ApiAttachmentsGetCollectionError,
  ApiAttachmentsPostData,
  ApiAttachmentsPostResponse,
  ApiAttachmentsPostError,
  ApiAttachmentsIdDeleteData,
  ApiAttachmentsIdDeleteResponse,
  ApiAttachmentsIdDeleteError,
  ApiAttachmentsIdGetData,
  ApiAttachmentsIdGetResponse,
  ApiAttachmentsIdGetError,
  ApiAttachmentsIdPutData,
  ApiAttachmentsIdPutResponse,
  ApiAttachmentsIdPutError,
  ApiBusinessPartnersGetCollectionData,
  ApiBusinessPartnersGetCollectionResponse,
  ApiBusinessPartnersPostData,
  ApiBusinessPartnersPostResponse,
  ApiBusinessPartnersPostError,
  BusinessPartnersShortData,
  ApiBusinessPartnersCodeGetData,
  ApiBusinessPartnersCodeGetResponse,
  ApiBusinessPartnersCodeGetError,
  ApiBusinessPartnersCodePutData,
  ApiBusinessPartnersCodePutResponse,
  ApiBusinessPartnersCodePutError,
  ApiBusinessPartnerCredentialsPostData,
  ApiBusinessPartnerCredentialsPostResponse,
  ApiBusinessPartnerCredentialsPostError,
  ApiBusinessPartnerCredentialUpdatesPostData,
  ApiBusinessPartnerCredentialUpdatesPostResponse,
  ApiBusinessPartnerCredentialUpdatesPostError,
  ApiBusinessPartnerEvaluationsPostData,
  ApiBusinessPartnerEvaluationsPostResponse,
  ApiBusinessPartnerEvaluationsPostError,
  ApiBusinessPartnerEvaluationUpdatesPostData,
  ApiBusinessPartnerEvaluationUpdatesPostResponse,
  ApiBusinessPartnerEvaluationUpdatesPostError,
  ApiCalendarEntriesGetCollectionData,
  ApiCalendarEntriesGetCollectionResponse,
  ApiCalendarEntriesPostData,
  ApiCalendarEntriesPostResponse,
  ApiCalendarEntriesPostError,
  ApiCalendarEntriesIdDeleteData,
  ApiCalendarEntriesIdDeleteResponse,
  ApiCalendarEntriesIdDeleteError,
  ApiCalendarEntriesIdGetData,
  ApiCalendarEntriesIdGetResponse,
  ApiCalendarEntriesIdGetError,
  ApiCalendarEntriesIdPutData,
  ApiCalendarEntriesIdPutResponse,
  ApiCalendarEntriesIdPutError,
  ApiCalendarEntryTypesGetCollectionData,
  ApiCalendarEntryTypesGetCollectionResponse,
  ApiCalendarEntryTypesPostData,
  ApiCalendarEntryTypesPostResponse,
  ApiCalendarEntryTypesPostError,
  ApiCalendarEntryTypesIdDeleteData,
  ApiCalendarEntryTypesIdDeleteResponse,
  ApiCalendarEntryTypesIdDeleteError,
  ApiCalendarEntryTypesIdGetData,
  ApiCalendarEntryTypesIdGetResponse,
  ApiCalendarEntryTypesIdGetError,
  ApiCalendarEntryTypesIdPutData,
  ApiCalendarEntryTypesIdPutResponse,
  ApiCalendarEntryTypesIdPutError,
  ApiCalendarEventsGetCollectionData,
  ApiCalendarEventsGetCollectionResponse,
  ApiCalendarEventsPostData,
  ApiCalendarEventsPostResponse,
  ApiCalendarEventsPostError,
  ApiCalendarEventsIdDeleteData,
  ApiCalendarEventsIdDeleteResponse,
  ApiCalendarEventsIdDeleteError,
  ApiCalendarEventsIdGetData,
  ApiCalendarEventsIdGetResponse,
  ApiCalendarEventsIdGetError,
  ApiCalendarEventsIdPutData,
  ApiCalendarEventsIdPutResponse,
  ApiCalendarEventsIdPutError,
  ApiCmsPagesGetCollectionData,
  ApiCmsPagesGetCollectionResponse,
  ApiCmsPagesPostData,
  ApiCmsPagesPostResponse,
  ApiCmsPagesPostError,
  ApiCmsPagesIdDeleteData,
  ApiCmsPagesIdDeleteResponse,
  ApiCmsPagesIdDeleteError,
  ApiCmsPagesIdGetData,
  ApiCmsPagesIdGetResponse,
  ApiCmsPagesIdGetError,
  ApiCmsPagesIdPutData,
  ApiCmsPagesIdPutResponse,
  ApiCmsPagesIdPutError,
  ApiConfigsGetCollectionData,
  ApiConfigsGetCollectionResponse,
  ApiConfigsIdGetData,
  ApiConfigsIdGetResponse,
  ApiConfigsIdGetError,
  ApiConfigsIdPutData,
  ApiConfigsIdPutResponse,
  ApiConfigsIdPutError,
  ApiContactsGetCollectionData,
  ApiContactsGetCollectionResponse,
  ApiContactsPostData,
  ApiContactsPostResponse,
  ApiContactsPostError,
  ApiContactsIdGetData,
  ApiContactsIdGetResponse,
  ApiContactsIdGetError,
  ApiContactsIdPutData,
  ApiContactsIdPutResponse,
  ApiContactsIdPutError,
  ApiCronJobLogsGetCollectionData,
  ApiCronJobLogsGetCollectionResponse,
  ApiCronJobLogsGetCollectionError,
  ApiCronJobLogsIdGetData,
  ApiCronJobLogsIdGetResponse,
  ApiCronJobLogsIdGetError,
  ApiDashboardsGetCollectionData,
  ApiDashboardsGetCollectionResponse,
  ApiDashboardsPostData,
  ApiDashboardsPostResponse,
  ApiDashboardsPostError,
  ApiDashboardsIdGetData,
  ApiDashboardsIdGetResponse,
  ApiDashboardsIdGetError,
  ApiDashboardsIdPutData,
  ApiDashboardsIdPutResponse,
  ApiDashboardsIdPutError,
  ApiDashboardWidgetsGetCollectionData,
  ApiDashboardWidgetsGetCollectionResponse,
  ApiDashboardWidgetsPostData,
  ApiDashboardWidgetsPostResponse,
  ApiDashboardWidgetsPostError,
  ApiDashboardWidgetsIdDeleteData,
  ApiDashboardWidgetsIdDeleteResponse,
  ApiDashboardWidgetsIdDeleteError,
  ApiDashboardWidgetsIdGetData,
  ApiDashboardWidgetsIdGetResponse,
  ApiDashboardWidgetsIdGetError,
  ApiDashboardWidgetsIdPutData,
  ApiDashboardWidgetsIdPutResponse,
  ApiDashboardWidgetsIdPutError,
  ApiDepartmentsGetCollectionData,
  ApiDepartmentsGetCollectionResponse,
  ApiDepartmentsPostData,
  ApiDepartmentsPostResponse,
  ApiDepartmentsPostError,
  ApiDepartmentsIdGetData,
  ApiDepartmentsIdGetResponse,
  ApiDepartmentsIdGetError,
  ApiDepartmentsIdPutData,
  ApiDepartmentsIdPutResponse,
  ApiDepartmentsIdPutError,
  ApiEffortsGetCollectionData,
  ApiEffortsGetCollectionResponse,
  ApiEffortsPostData,
  ApiEffortsPostResponse,
  ApiEffortsPostError,
  ApiEffortsIdDeleteData,
  ApiEffortsIdDeleteResponse,
  ApiEffortsIdDeleteError,
  ApiEffortsIdGetData,
  ApiEffortsIdGetResponse,
  ApiEffortsIdGetError,
  ApiEffortsIdPutData,
  ApiEffortsIdPutResponse,
  ApiEffortsIdPutError,
  ApiEffortsIdchildrenGetCollectionData,
  ApiEffortsIdchildrenGetCollectionResponse,
  EffortPropertiesFastData,
  EffortPropertiesFastResponse,
  EffortsExtendedData,
  EffortsExtendedResponse,
  ApiEffortsLastUsedGetCollectionData,
  ApiEffortsLastUsedGetCollectionResponse,
  ApiEffortsLostBudgetGetCollectionData,
  ApiEffortsLostBudgetGetCollectionResponse,
  ApiEffortsMyAssignmentsGetCollectionData,
  ApiEffortsMyAssignmentsGetCollectionResponse,
  ApiEffortsMyPriorizedGetCollectionData,
  ApiEffortsMyPriorizedGetCollectionResponse,
  ApiEffortsPriorizedGetCollectionData,
  ApiEffortsPriorizedGetCollectionResponse,
  EffortsShortData,
  EffortsShortResponse,
  ApiEffortsUnsyncedGetCollectionData,
  ApiEffortsUnsyncedGetCollectionResponse,
  ApiEffortBucketsGetCollectionData,
  ApiEffortBucketsGetCollectionResponse,
  ApiEffortBucketsPostData,
  ApiEffortBucketsPostResponse,
  ApiEffortBucketsPostError,
  ApiEffortBucketsIdDeleteData,
  ApiEffortBucketsIdDeleteResponse,
  ApiEffortBucketsIdDeleteError,
  ApiEffortBucketsIdGetData,
  ApiEffortBucketsIdGetResponse,
  ApiEffortBucketsIdGetError,
  ApiEffortBucketsIdPutData,
  ApiEffortBucketsIdPutResponse,
  ApiEffortBucketsIdPutError,
  ApiEffortChannelsGetCollectionData,
  ApiEffortChannelsGetCollectionResponse,
  ApiEffortChannelsPostData,
  ApiEffortChannelsPostResponse,
  ApiEffortChannelsPostError,
  ApiEffortChannelsIdDeleteData,
  ApiEffortChannelsIdDeleteResponse,
  ApiEffortChannelsIdDeleteError,
  ApiEffortChannelsIdGetData,
  ApiEffortChannelsIdGetResponse,
  ApiEffortChannelsIdGetError,
  ApiEffortChannelsIdPutData,
  ApiEffortChannelsIdPutResponse,
  ApiEffortChannelsIdPutError,
  ApiEffortChannelItemsGetCollectionData,
  ApiEffortChannelItemsGetCollectionResponse,
  ApiEffortChannelItemsPostData,
  ApiEffortChannelItemsPostResponse,
  ApiEffortChannelItemsPostError,
  ApiEffortChannelItemsIdDeleteData,
  ApiEffortChannelItemsIdDeleteResponse,
  ApiEffortChannelItemsIdDeleteError,
  ApiEffortChannelItemsIdGetData,
  ApiEffortChannelItemsIdGetResponse,
  ApiEffortChannelItemsIdGetError,
  ApiEffortChannelItemsIdPutData,
  ApiEffortChannelItemsIdPutResponse,
  ApiEffortChannelItemsIdPutError,
  ApiEffortDrivingsGetCollectionData,
  ApiEffortDrivingsGetCollectionResponse,
  ApiEffortDrivingsPostData,
  ApiEffortDrivingsPostResponse,
  ApiEffortDrivingsPostError,
  ApiEffortDrivingsIdDeleteData,
  ApiEffortDrivingsIdDeleteResponse,
  ApiEffortDrivingsIdDeleteError,
  ApiEffortDrivingsIdGetData,
  ApiEffortDrivingsIdGetResponse,
  ApiEffortDrivingsIdGetError,
  ApiEffortDrivingsIdPutData,
  ApiEffortDrivingsIdPutResponse,
  ApiEffortDrivingsIdPutError,
  ApiEffortEntriesGetCollectionData,
  ApiEffortEntriesGetCollectionResponse,
  ApiEffortEntriesPostData,
  ApiEffortEntriesPostResponse,
  ApiEffortEntriesPostError,
  ApiEffortEntriesIdDeleteData,
  ApiEffortEntriesIdDeleteResponse,
  ApiEffortEntriesIdDeleteError,
  ApiEffortEntriesIdGetData,
  ApiEffortEntriesIdGetResponse,
  ApiEffortEntriesIdGetError,
  ApiEffortEntriesIdPutData,
  ApiEffortEntriesIdPutResponse,
  ApiEffortEntriesIdPutError,
  ApiEffortEntriesByPartnerPartnerGetCollectionData,
  ApiEffortEntriesByPartnerPartnerGetCollectionResponse,
  ApiEffortEntriesRecursiveEffortidGetCollectionData,
  ApiEffortEntriesRecursiveEffortidGetCollectionResponse,
  ApiEffortEntriesShortGetCollectionData,
  ApiEffortEntriesShortGetCollectionResponse,
  ApiEffortEntriesUnsyncedGetCollectionData,
  ApiEffortEntriesUnsyncedGetCollectionResponse,
  ApiEffortExpensesGetCollectionData,
  ApiEffortExpensesGetCollectionResponse,
  ApiEffortExpensesPostData,
  ApiEffortExpensesPostResponse,
  ApiEffortExpensesPostError,
  ApiEffortExpensesIdDeleteData,
  ApiEffortExpensesIdDeleteResponse,
  ApiEffortExpensesIdDeleteError,
  ApiEffortExpensesIdGetData,
  ApiEffortExpensesIdGetResponse,
  ApiEffortExpensesIdGetError,
  ApiEffortExpensesIdPutData,
  ApiEffortExpensesIdPutResponse,
  ApiEffortExpensesIdPutError,
  ApiEffortExpensesIdattachmentPostData,
  ApiEffortExpensesIdattachmentPostResponse,
  ApiEffortExpensesIdattachmentPostError,
  ApiEffortLinksGetCollectionData,
  ApiEffortLinksGetCollectionResponse,
  ApiEffortLinksPostData,
  ApiEffortLinksPostResponse,
  ApiEffortLinksPostError,
  ApiEffortLinksIdDeleteData,
  ApiEffortLinksIdDeleteResponse,
  ApiEffortLinksIdDeleteError,
  ApiEffortLinksIdGetData,
  ApiEffortLinksIdGetResponse,
  ApiEffortLinksIdGetError,
  ApiEffortLinksIdPutData,
  ApiEffortLinksIdPutResponse,
  ApiEffortLinksIdPutError,
  ApiEffortMembersGetCollectionData,
  ApiEffortMembersGetCollectionResponse,
  ApiEffortMembersPostData,
  ApiEffortMembersPostResponse,
  ApiEffortMembersPostError,
  ApiEffortMembersIdDeleteData,
  ApiEffortMembersIdDeleteResponse,
  ApiEffortMembersIdDeleteError,
  ApiEffortMembersIdGetData,
  ApiEffortMembersIdGetResponse,
  ApiEffortMembersIdGetError,
  ApiEffortMembersIdPutData,
  ApiEffortMembersIdPutResponse,
  ApiEffortMembersIdPutError,
  ApiEffortNotesGetCollectionData,
  ApiEffortNotesGetCollectionResponse,
  ApiEffortNotesPostData,
  ApiEffortNotesPostResponse,
  ApiEffortNotesPostError,
  ApiEffortNotesIdDeleteData,
  ApiEffortNotesIdDeleteResponse,
  ApiEffortNotesIdDeleteError,
  ApiEffortNotesIdGetData,
  ApiEffortNotesIdGetResponse,
  ApiEffortNotesIdGetError,
  ApiEffortNotesIdPutData,
  ApiEffortNotesIdPutResponse,
  ApiEffortNotesIdPutError,
  ApiEffortOvernightStaysGetCollectionData,
  ApiEffortOvernightStaysGetCollectionResponse,
  ApiEffortOvernightStaysPostData,
  ApiEffortOvernightStaysPostResponse,
  ApiEffortOvernightStaysPostError,
  ApiEffortOvernightStaysIdDeleteData,
  ApiEffortOvernightStaysIdDeleteResponse,
  ApiEffortOvernightStaysIdDeleteError,
  ApiEffortOvernightStaysIdGetData,
  ApiEffortOvernightStaysIdGetResponse,
  ApiEffortOvernightStaysIdGetError,
  ApiEffortOvernightStaysIdPutData,
  ApiEffortOvernightStaysIdPutResponse,
  ApiEffortOvernightStaysIdPutError,
  ApiEffortOvernightStaysIdattachmentPostData,
  ApiEffortOvernightStaysIdattachmentPostResponse,
  ApiEffortOvernightStaysIdattachmentPostError,
  ApiEffortPropertiesPostData,
  ApiEffortPropertiesPostResponse,
  ApiEffortPropertiesPostError,
  ApiEffortPropertiesIdDeleteData,
  ApiEffortPropertiesIdDeleteResponse,
  ApiEffortPropertiesIdDeleteError,
  ApiEffortStatesGetCollectionData,
  ApiEffortStatesGetCollectionResponse,
  ApiEffortStatesPostData,
  ApiEffortStatesPostResponse,
  ApiEffortStatesPostError,
  ApiEffortStatesIdDeleteData,
  ApiEffortStatesIdDeleteResponse,
  ApiEffortStatesIdDeleteError,
  ApiEffortStatesIdGetData,
  ApiEffortStatesIdGetResponse,
  ApiEffortStatesIdGetError,
  ApiEffortStatesIdPutData,
  ApiEffortStatesIdPutResponse,
  ApiEffortStatesIdPutError,
  ApiEffortTreesIdGetData,
  ApiEffortTreesIdGetResponse,
  ApiEffortTreesIdGetError,
  ApiEffortTypesGetCollectionData,
  ApiEffortTypesGetCollectionResponse,
  ApiEffortTypesPostData,
  ApiEffortTypesPostResponse,
  ApiEffortTypesPostError,
  ApiEffortTypesIdDeleteData,
  ApiEffortTypesIdDeleteResponse,
  ApiEffortTypesIdDeleteError,
  ApiEffortTypesIdGetData,
  ApiEffortTypesIdGetResponse,
  ApiEffortTypesIdGetError,
  ApiEffortTypesIdPutData,
  ApiEffortTypesIdPutResponse,
  ApiEffortTypesIdPutError,
  ApiAuth2FaverifyPostData,
  ApiAuth2FaverifyPostResponse,
  ApiAuth2FaverifyPostError,
  ApiEmployeesGetCollectionData,
  ApiEmployeesGetCollectionResponse,
  ApiEmployeesPostData,
  ApiEmployeesPostResponse,
  ApiEmployeesPostError,
  ApiEmployeesIdGetData,
  ApiEmployeesIdGetResponse,
  ApiEmployeesIdGetError,
  ApiEmployeesIdPutData,
  ApiEmployeesIdPutResponse,
  ApiEmployeesIdPutError,
  ApiEmployeesIdavatarDeleteData,
  ApiEmployeesIdavatarDeleteResponse,
  ApiEmployeesIdavatarDeleteError,
  ApiEmployeesIdavatarPostData,
  ApiEmployeesIdavatarPostResponse,
  ApiEmployeesIdavatarPostError,
  ApiEmployeeApiTokensPostData,
  ApiEmployeeApiTokensPostResponse,
  ApiEmployeeApiTokensPostError,
  ApiEmployeeApiTokensIdDeleteData,
  ApiEmployeeApiTokensIdDeleteResponse,
  ApiEmployeeApiTokensIdDeleteError,
  ApiEmployeeApiTokensIdPutData,
  ApiEmployeeApiTokensIdPutResponse,
  ApiEmployeeApiTokensIdPutError,
  ApiEmployeeAvatarsGetCollectionData,
  ApiEmployeeAvatarsGetCollectionResponse,
  ApiEmployeeAvatarsEmployeeGetData,
  ApiEmployeeAvatarsEmployeeGetResponse,
  ApiEmployeeAvatarsEmployeeGetError,
  ApiEmployeeBalancesGetCollectionData,
  ApiEmployeeBalancesGetCollectionResponse,
  ApiEmployeeBalancesPostData,
  ApiEmployeeBalancesPostResponse,
  ApiEmployeeBalancesPostError,
  ApiEmployeeBalancesIdDeleteData,
  ApiEmployeeBalancesIdDeleteResponse,
  ApiEmployeeBalancesIdDeleteError,
  ApiEmployeeBalancesIdGetData,
  ApiEmployeeBalancesIdGetResponse,
  ApiEmployeeBalancesIdGetError,
  ApiEmployeeBalancesIdPutData,
  ApiEmployeeBalancesIdPutResponse,
  ApiEmployeeBalancesIdPutError,
  ApiEmployeeConfigsGetCollectionData,
  ApiEmployeeConfigsGetCollectionResponse,
  ApiEmployeeConfigsPostData,
  ApiEmployeeConfigsPostResponse,
  ApiEmployeeConfigsPostError,
  ApiEmployeeConfigsIdDeleteData,
  ApiEmployeeConfigsIdDeleteResponse,
  ApiEmployeeConfigsIdDeleteError,
  ApiEmployeeConfigsIdGetData,
  ApiEmployeeConfigsIdGetResponse,
  ApiEmployeeConfigsIdGetError,
  ApiEmployeeConfigDefaultsGetCollectionData,
  ApiEmployeeConfigDefaultsGetCollectionResponse,
  ApiEmployeeConfigDefaultsPostData,
  ApiEmployeeConfigDefaultsPostResponse,
  ApiEmployeeConfigDefaultsPostError,
  ApiEmployeeConfigDefaultsKeyGetData,
  ApiEmployeeConfigDefaultsKeyGetResponse,
  ApiEmployeeConfigDefaultsKeyGetError,
  ApiEmployeeConfigDefaultsKeyPutData,
  ApiEmployeeConfigDefaultsKeyPutResponse,
  ApiEmployeeConfigDefaultsKeyPutError,
  ApiEmployeeFavoritesGetCollectionData,
  ApiEmployeeFavoritesGetCollectionResponse,
  ApiEmployeeFavoritesPostData,
  ApiEmployeeFavoritesPostResponse,
  ApiEmployeeFavoritesPostError,
  ApiEmployeeFavoritesIdDeleteData,
  ApiEmployeeFavoritesIdDeleteResponse,
  ApiEmployeeFavoritesIdDeleteError,
  ApiEmployeeFavoritesIdGetData,
  ApiEmployeeFavoritesIdGetResponse,
  ApiEmployeeFavoritesIdGetError,
  ApiEmployeeFavoritesIdPutData,
  ApiEmployeeFavoritesIdPutResponse,
  ApiEmployeeFavoritesIdPutError,
  ApiEmployeeHobbiesGetCollectionData,
  ApiEmployeeHobbiesGetCollectionResponse,
  ApiEmployeeMailsGetCollectionData,
  ApiEmployeeMailsGetCollectionResponse,
  ApiEmployeeMailsPostData,
  ApiEmployeeMailsPostResponse,
  ApiEmployeeMailsPostError,
  ApiEmployeeMailsIdDeleteData,
  ApiEmployeeMailsIdDeleteResponse,
  ApiEmployeeMailsIdDeleteError,
  ApiEmployeeMailsIdGetData,
  ApiEmployeeMailsIdGetResponse,
  ApiEmployeeMailsIdGetError,
  ApiEmployeeMailsIdPutData,
  ApiEmployeeMailsIdPutResponse,
  ApiEmployeeMailsIdPutError,
  ApiEmployeeMailFoldersGetCollectionData,
  ApiEmployeeMailFoldersGetCollectionResponse,
  ApiEmployeeMailFoldersPostData,
  ApiEmployeeMailFoldersPostResponse,
  ApiEmployeeMailFoldersPostError,
  ApiEmployeeMailFoldersIdDeleteData,
  ApiEmployeeMailFoldersIdDeleteResponse,
  ApiEmployeeMailFoldersIdDeleteError,
  ApiEmployeeMailFoldersIdGetData,
  ApiEmployeeMailFoldersIdGetResponse,
  ApiEmployeeMailFoldersIdGetError,
  ApiEmployeeMailFoldersIdPutData,
  ApiEmployeeMailFoldersIdPutResponse,
  ApiEmployeeMailFoldersIdPutError,
  ApiEmployeeNotificationsGetCollectionData,
  ApiEmployeeNotificationsGetCollectionResponse,
  ApiEmployeeNotificationsIdGetData,
  ApiEmployeeNotificationsIdGetResponse,
  ApiEmployeeNotificationsIdGetError,
  ApiEmployeeNotificationsIdPutData,
  ApiEmployeeNotificationsIdPutResponse,
  ApiEmployeeNotificationsIdPutError,
  ApiEmployeeNotificationSettingsGetCollectionData,
  ApiEmployeeNotificationSettingsGetCollectionResponse,
  ApiEmployeeNotificationSettingsPostData,
  ApiEmployeeNotificationSettingsPostResponse,
  ApiEmployeeNotificationSettingsPostError,
  ApiEmployeeNotificationSettingsIdDeleteData,
  ApiEmployeeNotificationSettingsIdDeleteResponse,
  ApiEmployeeNotificationSettingsIdDeleteError,
  ApiEmployeeNotificationSettingsIdGetData,
  ApiEmployeeNotificationSettingsIdGetResponse,
  ApiEmployeeNotificationSettingsIdGetError,
  ApiEmployeeNotificationSettingsIdPutData,
  ApiEmployeeNotificationSettingsIdPutResponse,
  ApiEmployeeNotificationSettingsIdPutError,
  ApiEmployeeProfilesIdGetData,
  ApiEmployeeProfilesIdGetResponse,
  ApiEmployeeProfilesIdGetError,
  ApiEmployeeProfilesIdPutData,
  ApiEmployeeProfilesIdPutResponse,
  ApiEmployeeProfilesIdPutError,
  ApiEmployeeProgressiveSkillsGetCollectionData,
  ApiEmployeeProgressiveSkillsGetCollectionResponse,
  ApiEmployeeSkillsGetCollectionData,
  ApiEmployeeSkillsGetCollectionResponse,
  ApiEmployeeStatesGetCollectionData,
  ApiEmployeeStatesGetCollectionResponse,
  ApiEmployeeStatesPostData,
  ApiEmployeeStatesPostResponse,
  ApiEmployeeStatesPostError,
  ApiEmployeeStatesIdGetData,
  ApiEmployeeStatesIdGetResponse,
  ApiEmployeeStatesIdGetError,
  ApiEmployeeStatesIdPutData,
  ApiEmployeeStatesIdPutResponse,
  ApiEmployeeStatesIdPutError,
  ApiEmployeeStateHistoriesGetCollectionData,
  ApiEmployeeStateHistoriesGetCollectionResponse,
  ApiEmployeeStateHistoriesPostData,
  ApiEmployeeStateHistoriesPostResponse,
  ApiEmployeeStateHistoriesPostError,
  ApiEmployeeStateHistoriesIdDeleteData,
  ApiEmployeeStateHistoriesIdDeleteResponse,
  ApiEmployeeStateHistoriesIdDeleteError,
  ApiEmployeeStateHistoriesIdGetData,
  ApiEmployeeStateHistoriesIdGetResponse,
  ApiEmployeeStateHistoriesIdGetError,
  ApiEmployeeStateHistoriesIdPutData,
  ApiEmployeeStateHistoriesIdPutResponse,
  ApiEmployeeStateHistoriesIdPutError,
  ApiEmployeeStateStampsGetCollectionData,
  ApiEmployeeStateStampsGetCollectionResponse,
  ApiEmployeeStateStampsPostData,
  ApiEmployeeStateStampsPostResponse,
  ApiEmployeeStateStampsPostError,
  ApiEmployeeStateStampsIdDeleteData,
  ApiEmployeeStateStampsIdDeleteResponse,
  ApiEmployeeStateStampsIdDeleteError,
  ApiEmployeeStateStampsIdGetData,
  ApiEmployeeStateStampsIdGetResponse,
  ApiEmployeeStateStampsIdGetError,
  ApiEmployeeStateStampsIdPutData,
  ApiEmployeeStateStampsIdPutResponse,
  ApiEmployeeStateStampsIdPutError,
  ApiEmployeeSubscriptionsPostData,
  ApiEmployeeSubscriptionsPostResponse,
  ApiEmployeeSubscriptionsPostError,
  ErrorTestGetData,
  ErrorTestGetResponse,
  ErrorTestGetError,
  ErrorTestPostData,
  ErrorTestPostResponse,
  ErrorTestPostError,
  ApiExpenseTypesGetCollectionData,
  ApiExpenseTypesGetCollectionResponse,
  ApiExpenseTypesPostData,
  ApiExpenseTypesPostResponse,
  ApiExpenseTypesPostError,
  ApiExpenseTypesIdGetData,
  ApiExpenseTypesIdGetResponse,
  ApiExpenseTypesIdGetError,
  ApiExpenseTypesIdPutData,
  ApiExpenseTypesIdPutResponse,
  ApiExpenseTypesIdPutError,
  ApiFeatureFlagsGetCollectionData,
  ApiFeatureFlagsGetCollectionResponse,
  ApiFeatureFlagsPostData,
  ApiFeatureFlagsPostResponse,
  ApiFeatureFlagsPostError,
  ApiFeatureFlagsIdDeleteData,
  ApiFeatureFlagsIdDeleteResponse,
  ApiFeatureFlagsIdDeleteError,
  ApiFeatureFlagsIdGetData,
  ApiFeatureFlagsIdGetResponse,
  ApiFeatureFlagsIdGetError,
  ApiFeatureFlagsIdPutData,
  ApiFeatureFlagsIdPutResponse,
  ApiFeatureFlagsIdPutError,
  ApiFilterBuildersPostData,
  ApiFilterBuildersPostResponse,
  ApiFilterBuildersPostError,
  ApiGitlabAuthorsGetCollectionData,
  ApiGitlabAuthorsGetCollectionResponse,
  ApiGitlabAuthorsPostData,
  ApiGitlabAuthorsPostResponse,
  ApiGitlabAuthorsPostError,
  ApiGitlabAuthorsTidGetData,
  ApiGitlabAuthorsTidGetResponse,
  ApiGitlabAuthorsTidGetError,
  ApiGitlabAuthorsTidPatchData,
  ApiGitlabAuthorsTidPatchResponse,
  ApiGitlabAuthorsTidPatchError,
  ApiGitlabAuthorsTidPutData,
  ApiGitlabAuthorsTidPutResponse,
  ApiGitlabAuthorsTidPutError,
  ApiGitlabCommitsGetCollectionData,
  ApiGitlabCommitsGetCollectionResponse,
  ApiGitlabCommitsPostData,
  ApiGitlabCommitsPostResponse,
  ApiGitlabCommitsPostError,
  ApiGitlabCommitsIdGetData,
  ApiGitlabCommitsIdGetResponse,
  ApiGitlabCommitsIdGetError,
  ApiGitlabCommitsIdPatchData,
  ApiGitlabCommitsIdPatchResponse,
  ApiGitlabCommitsIdPatchError,
  ApiGitlabCommitsIdPutData,
  ApiGitlabCommitsIdPutResponse,
  ApiGitlabCommitsIdPutError,
  ApiGitlabProjectsGetCollectionData,
  ApiGitlabProjectsGetCollectionResponse,
  ApiGitlabProjectsPostData,
  ApiGitlabProjectsPostResponse,
  ApiGitlabProjectsPostError,
  ApiGitlabProjectsIdGetData,
  ApiGitlabProjectsIdGetResponse,
  ApiGitlabProjectsIdGetError,
  ApiGitlabProjectsIdPatchData,
  ApiGitlabProjectsIdPatchResponse,
  ApiGitlabProjectsIdPatchError,
  ApiGitlabProjectsIdPutData,
  ApiGitlabProjectsIdPutResponse,
  ApiGitlabProjectsIdPutError,
  ApiGitlabPushesGetCollectionData,
  ApiGitlabPushesGetCollectionResponse,
  ApiGitlabPushesPostData,
  ApiGitlabPushesPostResponse,
  ApiGitlabPushesPostError,
  ApiGitlabPushesTidGetData,
  ApiGitlabPushesTidGetResponse,
  ApiGitlabPushesTidGetError,
  ApiGitlabPushesTidPatchData,
  ApiGitlabPushesTidPatchResponse,
  ApiGitlabPushesTidPatchError,
  ApiGitlabPushesTidPutData,
  ApiGitlabPushesTidPutResponse,
  ApiGitlabPushesTidPutError,
  ApiGitlabRepositoriesGetCollectionData,
  ApiGitlabRepositoriesGetCollectionResponse,
  ApiGitlabRepositoriesPostData,
  ApiGitlabRepositoriesPostResponse,
  ApiGitlabRepositoriesPostError,
  ApiGitlabRepositoriesTidGetData,
  ApiGitlabRepositoriesTidGetResponse,
  ApiGitlabRepositoriesTidGetError,
  ApiGitlabRepositoriesTidPatchData,
  ApiGitlabRepositoriesTidPatchResponse,
  ApiGitlabRepositoriesTidPatchError,
  ApiGitlabRepositoriesTidPutData,
  ApiGitlabRepositoriesTidPutResponse,
  ApiGitlabRepositoriesTidPutError,
  ApiGlobalSearchesPostData,
  ApiGlobalSearchesPostResponse,
  ApiGlobalSearchesPostError,
  ApiImprovementsGetCollectionData,
  ApiImprovementsGetCollectionResponse,
  ApiImprovementsPostData,
  ApiImprovementsPostResponse,
  ApiImprovementsPostError,
  ApiImprovementsIdDeleteData,
  ApiImprovementsIdDeleteResponse,
  ApiImprovementsIdDeleteError,
  ApiImprovementsIdGetData,
  ApiImprovementsIdGetResponse,
  ApiImprovementsIdGetError,
  ApiImprovementsIdPutData,
  ApiImprovementsIdPutResponse,
  ApiImprovementsIdPutError,
  ApiImprovementsIdvoteDownPostData,
  ApiImprovementsIdvoteDownPostResponse,
  ApiImprovementsIdvoteDownPostError,
  ApiImprovementsIdvoteUpPostData,
  ApiImprovementsIdvoteUpPostResponse,
  ApiImprovementsIdvoteUpPostError,
  ApiImprovementScopesGetCollectionData,
  ApiImprovementScopesGetCollectionResponse,
  ApiImprovementScopesPostData,
  ApiImprovementScopesPostResponse,
  ApiImprovementScopesPostError,
  ApiImprovementScopesIdDeleteData,
  ApiImprovementScopesIdDeleteResponse,
  ApiImprovementScopesIdDeleteError,
  ApiImprovementScopesIdGetData,
  ApiImprovementScopesIdGetResponse,
  ApiImprovementScopesIdGetError,
  ApiImprovementScopesIdPutData,
  ApiImprovementScopesIdPutResponse,
  ApiImprovementScopesIdPutError,
  ApiImprovementThreadsGetCollectionData,
  ApiImprovementThreadsGetCollectionResponse,
  ApiImprovementThreadsPostData,
  ApiImprovementThreadsPostResponse,
  ApiImprovementThreadsPostError,
  ApiImprovementThreadsIdDeleteData,
  ApiImprovementThreadsIdDeleteResponse,
  ApiImprovementThreadsIdDeleteError,
  ApiImprovementThreadsIdGetData,
  ApiImprovementThreadsIdGetResponse,
  ApiImprovementThreadsIdGetError,
  ApiImprovementThreadsIdPutData,
  ApiImprovementThreadsIdPutResponse,
  ApiImprovementThreadsIdPutError,
  ApiImprovementTopicsGetCollectionData,
  ApiImprovementTopicsGetCollectionResponse,
  ApiImprovementTopicsPostData,
  ApiImprovementTopicsPostResponse,
  ApiImprovementTopicsPostError,
  ApiImprovementTopicsIdDeleteData,
  ApiImprovementTopicsIdDeleteResponse,
  ApiImprovementTopicsIdDeleteError,
  ApiImprovementTopicsIdGetData,
  ApiImprovementTopicsIdGetResponse,
  ApiImprovementTopicsIdGetError,
  ApiImprovementTopicsIdPutData,
  ApiImprovementTopicsIdPutResponse,
  ApiImprovementTopicsIdPutError,
  ApiInfoboardEntriesGetCollectionData,
  ApiInfoboardEntriesGetCollectionResponse,
  ApiInfoboardEntriesPostData,
  ApiInfoboardEntriesPostResponse,
  ApiInfoboardEntriesPostError,
  ApiInfoboardEntriesIdDeleteData,
  ApiInfoboardEntriesIdDeleteResponse,
  ApiInfoboardEntriesIdDeleteError,
  ApiInfoboardEntriesIdGetData,
  ApiInfoboardEntriesIdGetResponse,
  ApiInfoboardEntriesIdGetError,
  ApiInfoboardEntriesIdPutData,
  ApiInfoboardEntriesIdPutResponse,
  ApiInfoboardEntriesIdPutError,
  ApiInfoboardEntryUserMetasGetCollectionData,
  ApiInfoboardEntryUserMetasGetCollectionResponse,
  ApiInfoboardEntryUserMetasPostData,
  ApiInfoboardEntryUserMetasPostResponse,
  ApiInfoboardEntryUserMetasPostError,
  ApiInfoboardEntryUserMetasIdDeleteData,
  ApiInfoboardEntryUserMetasIdDeleteResponse,
  ApiInfoboardEntryUserMetasIdDeleteError,
  ApiInfoboardEntryUserMetasIdGetData,
  ApiInfoboardEntryUserMetasIdGetResponse,
  ApiInfoboardEntryUserMetasIdGetError,
  ApiInfoboardEntryUserMetasIdPutData,
  ApiInfoboardEntryUserMetasIdPutResponse,
  ApiInfoboardEntryUserMetasIdPutError,
  ApiInfoboardResponsesGetCollectionData,
  ApiInfoboardResponsesGetCollectionResponse,
  ApiInfoboardResponsesPostData,
  ApiInfoboardResponsesPostResponse,
  ApiInfoboardResponsesPostError,
  ApiInfoboardResponsesIdDeleteData,
  ApiInfoboardResponsesIdDeleteResponse,
  ApiInfoboardResponsesIdDeleteError,
  ApiInfoboardResponsesIdGetData,
  ApiInfoboardResponsesIdGetResponse,
  ApiInfoboardResponsesIdGetError,
  ApiInfoboardResponsesIdPutData,
  ApiInfoboardResponsesIdPutResponse,
  ApiInfoboardResponsesIdPutError,
  ApiJourFixeEntriesGetCollectionData,
  ApiJourFixeEntriesGetCollectionResponse,
  ApiJourFixeEntriesGetCollectionError,
  ApiJourFixeEntriesPostData,
  ApiJourFixeEntriesPostResponse,
  ApiJourFixeEntriesPostError,
  ApiJourFixeEntriesIdGetData,
  ApiJourFixeEntriesIdGetResponse,
  ApiJourFixeEntriesIdGetError,
  ApiJourFixeEntriesIdPatchData,
  ApiJourFixeEntriesIdPatchResponse,
  ApiJourFixeEntriesIdPatchError,
  ApiJourFixeEntriesIdPutData,
  ApiJourFixeEntriesIdPutResponse,
  ApiJourFixeEntriesIdPutError,
  ApiKioskAccessesDeviceIdGetData,
  ApiKioskAccessesDeviceIdGetResponse,
  ApiKioskAccessesDeviceIdGetError,
  ApiKioskAccessesDeviceIdPutData,
  ApiKioskAccessesDeviceIdPutResponse,
  ApiKioskAccessesDeviceIdPutError,
  KioskAuthData,
  KioskAuthResponse,
  KioskAuthError,
  ApiKioskdataGetData,
  ApiKioskdataGetResponse,
  ApiKioskdataGetError,
  LoginLogoutData,
  LoginRefreshTokenData,
  LoginRefreshTokenResponse,
  LoginRefreshTokenError,
  LoginCheckPostData,
  LoginCheckPostResponse,
  ApiMailRecipientsGetCollectionData,
  ApiMailRecipientsGetCollectionResponse,
  ApiMailRecipientsPostData,
  ApiMailRecipientsPostResponse,
  ApiMailRecipientsPostError,
  ApiMailRecipientsIdDeleteData,
  ApiMailRecipientsIdDeleteResponse,
  ApiMailRecipientsIdDeleteError,
  ApiMailRecipientsIdGetData,
  ApiMailRecipientsIdGetResponse,
  ApiMailRecipientsIdGetError,
  ApiMailRecipientsIdPutData,
  ApiMailRecipientsIdPutResponse,
  ApiMailRecipientsIdPutError,
  MercureSubscribeData,
  MercureSubscribeResponse,
  MercureSubscribeError,
  ApiModulesGetCollectionData,
  ApiModulesGetCollectionResponse,
  ApiModulesPostData,
  ApiModulesPostResponse,
  ApiModulesPostError,
  ApiModulesIdDeleteData,
  ApiModulesIdDeleteResponse,
  ApiModulesIdDeleteError,
  ApiModulesIdGetData,
  ApiModulesIdGetResponse,
  ApiModulesIdGetError,
  ApiModulesIdPutData,
  ApiModulesIdPutResponse,
  ApiModulesIdPutError,
  ApiModuleChangeLogsGetCollectionData,
  ApiModuleChangeLogsGetCollectionResponse,
  ApiModuleChangeLogsPostData,
  ApiModuleChangeLogsPostResponse,
  ApiModuleChangeLogsPostError,
  ApiModuleChangeLogsIdDeleteData,
  ApiModuleChangeLogsIdDeleteResponse,
  ApiModuleChangeLogsIdDeleteError,
  ApiModuleChangeLogsIdGetData,
  ApiModuleChangeLogsIdGetResponse,
  ApiModuleChangeLogsIdGetError,
  ApiModuleChangeLogsIdPutData,
  ApiModuleChangeLogsIdPutResponse,
  ApiModuleChangeLogsIdPutError,
  ApiModuleGroupsGetCollectionData,
  ApiModuleGroupsGetCollectionResponse,
  ApiModuleGroupsPostData,
  ApiModuleGroupsPostResponse,
  ApiModuleGroupsPostError,
  ApiModuleGroupsIdDeleteData,
  ApiModuleGroupsIdDeleteResponse,
  ApiModuleGroupsIdDeleteError,
  ApiModuleGroupsIdGetData,
  ApiModuleGroupsIdGetResponse,
  ApiModuleGroupsIdGetError,
  ApiModuleGroupsIdPutData,
  ApiModuleGroupsIdPutResponse,
  ApiModuleGroupsIdPutError,
  ApiModuleHashtagsGetCollectionData,
  ApiModuleHashtagsGetCollectionResponse,
  ApiModuleHashtagsPostData,
  ApiModuleHashtagsPostResponse,
  ApiModuleHashtagsPostError,
  ApiModuleHashtagsIdDeleteData,
  ApiModuleHashtagsIdDeleteResponse,
  ApiModuleHashtagsIdDeleteError,
  ApiModuleHashtagsIdGetData,
  ApiModuleHashtagsIdGetResponse,
  ApiModuleHashtagsIdGetError,
  ApiModuleHashtagsIdPutData,
  ApiModuleHashtagsIdPutResponse,
  ApiModuleHashtagsIdPutError,
  ApiOrdersGetCollectionData,
  ApiOrdersGetCollectionResponse,
  ApiOrdersPostData,
  ApiOrdersPostResponse,
  ApiOrdersPostError,
  ApiOrdersIdDeleteData,
  ApiOrdersIdDeleteResponse,
  ApiOrdersIdDeleteError,
  ApiOrdersIdGetData,
  ApiOrdersIdGetResponse,
  ApiOrdersIdGetError,
  ApiOrdersIdPutData,
  ApiOrdersIdPutResponse,
  ApiOrdersIdPutError,
  ApiOrdersUnsyncedGetCollectionData,
  ApiOrdersUnsyncedGetCollectionResponse,
  ApiOrderStatesGetCollectionData,
  ApiOrderStatesGetCollectionResponse,
  ApiOrderStatesPostData,
  ApiOrderStatesPostResponse,
  ApiOrderStatesPostError,
  ApiOrderStatesIdDeleteData,
  ApiOrderStatesIdDeleteResponse,
  ApiOrderStatesIdDeleteError,
  ApiOrderStatesIdGetData,
  ApiOrderStatesIdGetResponse,
  ApiOrderStatesIdGetError,
  ApiOrderStatesIdPutData,
  ApiOrderStatesIdPutResponse,
  ApiOrderStatesIdPutError,
  ChangePasswordData,
  ChangePasswordResponse,
  ChangePasswordError,
  PasswordChangeConfirmData,
  RequestResetPasswordData,
  ResetPasswordData,
  ApiPlannerCalendarsGetCollectionData,
  ApiPlannerCalendarsGetCollectionResponse,
  ApiPlannerCalendarsPostData,
  ApiPlannerCalendarsPostResponse,
  ApiPlannerCalendarsPostError,
  ApiPlannerCalendarsIdDeleteData,
  ApiPlannerCalendarsIdDeleteResponse,
  ApiPlannerCalendarsIdDeleteError,
  ApiPlannerCalendarsIdGetData,
  ApiPlannerCalendarsIdGetResponse,
  ApiPlannerCalendarsIdGetError,
  ApiPlannerCalendarsIdPutData,
  ApiPlannerCalendarsIdPutResponse,
  ApiPlannerCalendarsIdPutError,
  ApiPlannerColorsGetCollectionData,
  ApiPlannerColorsGetCollectionResponse,
  ApiPlannerColorsPostData,
  ApiPlannerColorsPostResponse,
  ApiPlannerColorsPostError,
  ApiPlannerColorsIdDeleteData,
  ApiPlannerColorsIdDeleteResponse,
  ApiPlannerColorsIdDeleteError,
  ApiPlannerColorsIdGetData,
  ApiPlannerColorsIdGetResponse,
  ApiPlannerColorsIdGetError,
  ApiPlannerColorsIdPutData,
  ApiPlannerColorsIdPutResponse,
  ApiPlannerColorsIdPutError,
  ApiPlannerEntriesGetCollectionData,
  ApiPlannerEntriesGetCollectionResponse,
  ApiPlannerEntriesPostData,
  ApiPlannerEntriesPostResponse,
  ApiPlannerEntriesPostError,
  ApiPlannerEntriesIdDeleteData,
  ApiPlannerEntriesIdDeleteResponse,
  ApiPlannerEntriesIdDeleteError,
  ApiPlannerEntriesIdGetData,
  ApiPlannerEntriesIdGetResponse,
  ApiPlannerEntriesIdGetError,
  ApiPlannerEntriesIdPutData,
  ApiPlannerEntriesIdPutResponse,
  ApiPlannerEntriesIdPutError,
  ApiPlannerEntriesRangedDateStartDateEndGetCollectionData,
  ApiPlannerEntriesRangedDateStartDateEndGetCollectionResponse,
  ApiPlannerPermissionsGetCollectionData,
  ApiPlannerPermissionsGetCollectionResponse,
  ApiPlannerPermissionsPostData,
  ApiPlannerPermissionsPostResponse,
  ApiPlannerPermissionsPostError,
  ApiPlannerPermissionsIdDeleteData,
  ApiPlannerPermissionsIdDeleteResponse,
  ApiPlannerPermissionsIdDeleteError,
  ApiPlannerPermissionsIdGetData,
  ApiPlannerPermissionsIdGetResponse,
  ApiPlannerPermissionsIdGetError,
  ApiPlannerPermissionsIdPutData,
  ApiPlannerPermissionsIdPutResponse,
  ApiPlannerPermissionsIdPutError,
  ApiRolesGetCollectionData,
  ApiRolesGetCollectionResponse,
  ApiRolesPostData,
  ApiRolesPostResponse,
  ApiRolesPostError,
  ApiRolesIdGetData,
  ApiRolesIdGetResponse,
  ApiRolesIdGetError,
  ApiRolesIdPutData,
  ApiRolesIdPutResponse,
  ApiRolesIdPutError,
  ApiSentMailsGetCollectionData,
  ApiSentMailsGetCollectionResponse,
  ApiSentMailsGetCollectionError,
  ApiSentMailsPostData,
  ApiSentMailsPostResponse,
  ApiSentMailsPostError,
  ApiSentMailsIdGetData,
  ApiSentMailsIdGetResponse,
  ApiSentMailsIdGetError,
  ApiSentMailsIdPutData,
  ApiSentMailsIdPutResponse,
  ApiSentMailsIdPutError,
  ApiServiceRevenuesGetCollectionData,
  ApiServiceRevenuesGetCollectionResponse,
  ApiServiceRevenuesPostData,
  ApiServiceRevenuesPostResponse,
  ApiServiceRevenuesPostError,
  ApiServiceRevenuesIdDeleteData,
  ApiServiceRevenuesIdDeleteResponse,
  ApiServiceRevenuesIdDeleteError,
  ApiServiceRevenuesIdGetData,
  ApiServiceRevenuesIdGetResponse,
  ApiServiceRevenuesIdGetError,
  ApiServiceRevenuesIdPutData,
  ApiServiceRevenuesIdPutResponse,
  ApiServiceRevenuesIdPutError,
  ApiServiceTypesGetCollectionData,
  ApiServiceTypesGetCollectionResponse,
  ApiServiceTypesPostData,
  ApiServiceTypesPostResponse,
  ApiServiceTypesPostError,
  ApiServiceTypesIdGetData,
  ApiServiceTypesIdGetResponse,
  ApiServiceTypesIdGetError,
  ApiServiceTypesIdPutData,
  ApiServiceTypesIdPutResponse,
  ApiServiceTypesIdPutError,
  ApiSyncObjectsGetCollectionData,
  ApiSyncObjectsGetCollectionResponse,
  ApiSyncObjectsPostData,
  ApiSyncObjectsPostResponse,
  ApiSyncObjectsPostError,
  ApiSyncObjectsIdGetData,
  ApiSyncObjectsIdGetResponse,
  ApiSyncObjectsIdGetError,
  ApiSyncObjectsIdPutData,
  ApiSyncObjectsIdPutResponse,
  ApiSyncObjectsIdPutError,
  PingData,
  PingResponse,
  GetServerInfoData,
  GetServerInfoResponse,
  ApiTasksGetCollectionData,
  ApiTasksGetCollectionResponse,
  ApiTasksPostData,
  ApiTasksPostResponse,
  ApiTasksPostError,
  ApiTasksIdDeleteData,
  ApiTasksIdDeleteResponse,
  ApiTasksIdDeleteError,
  ApiTasksIdGetData,
  ApiTasksIdGetResponse,
  ApiTasksIdGetError,
  ApiTasksIdPutData,
  ApiTasksIdPutResponse,
  ApiTasksIdPutError,
  ApiTaskCommentsPostData,
  ApiTaskCommentsPostResponse,
  ApiTaskCommentsPostError,
  ApiTaskCommentsIdDeleteData,
  ApiTaskCommentsIdDeleteResponse,
  ApiTaskCommentsIdDeleteError,
  ApiTaskEstimationsGetCollectionData,
  ApiTaskEstimationsGetCollectionResponse,
  ApiTaskEstimationsPostData,
  ApiTaskEstimationsPostResponse,
  ApiTaskEstimationsPostError,
  ApiTaskEstimationsIdDeleteData,
  ApiTaskEstimationsIdDeleteResponse,
  ApiTaskEstimationsIdDeleteError,
  ApiTaskEstimationsIdGetData,
  ApiTaskEstimationsIdGetResponse,
  ApiTaskEstimationsIdGetError,
  ApiTaskEstimationsIdPutData,
  ApiTaskEstimationsIdPutResponse,
  ApiTaskEstimationsIdPutError,
  ApiTaskLinksPostData,
  ApiTaskLinksPostResponse,
  ApiTaskLinksPostError,
  ApiTaskLinksIdDeleteData,
  ApiTaskLinksIdDeleteResponse,
  ApiTaskLinksIdDeleteError,
  ApiTaskUserStoriesGetCollectionData,
  ApiTaskUserStoriesGetCollectionResponse,
  ApiTaskUserStoriesPostData,
  ApiTaskUserStoriesPostResponse,
  ApiTaskUserStoriesPostError,
  ApiTaskUserStoriesIdDeleteData,
  ApiTaskUserStoriesIdDeleteResponse,
  ApiTaskUserStoriesIdDeleteError,
  ApiTaskUserStoriesIdGetData,
  ApiTaskUserStoriesIdGetResponse,
  ApiTaskUserStoriesIdGetError,
  ApiTaskUserStoriesIdPutData,
  ApiTaskUserStoriesIdPutResponse,
  ApiTaskUserStoriesIdPutError,
  ApiTimePlanningEntriesGetCollectionData,
  ApiTimePlanningEntriesGetCollectionResponse,
  ApiTimePlanningEntriesPostData,
  ApiTimePlanningEntriesPostResponse,
  ApiTimePlanningEntriesPostError,
  ApiTimePlanningEntriesIdDeleteData,
  ApiTimePlanningEntriesIdDeleteResponse,
  ApiTimePlanningEntriesIdDeleteError,
  ApiTimePlanningEntriesIdGetData,
  ApiTimePlanningEntriesIdGetResponse,
  ApiTimePlanningEntriesIdGetError,
  ApiTimePlanningEntriesIdPutData,
  ApiTimePlanningEntriesIdPutResponse,
  ApiTimePlanningEntriesIdPutError,
  ApiTimeTrackingsGetCollectionData,
  ApiTimeTrackingsGetCollectionResponse,
  ApiTimeTrackingsPostData,
  ApiTimeTrackingsPostResponse,
  ApiTimeTrackingsPostError,
  ApiTimeTrackingsIdDeleteData,
  ApiTimeTrackingsIdDeleteResponse,
  ApiTimeTrackingsIdDeleteError,
  ApiTimeTrackingsIdGetData,
  ApiTimeTrackingsIdGetResponse,
  ApiTimeTrackingsIdGetError,
  ApiTimeTrackingsIdPutData,
  ApiTimeTrackingsIdPutResponse,
  ApiTimeTrackingsIdPutError,
  ApiTimeTrackingStampsGetCollectionData,
  ApiTimeTrackingStampsGetCollectionResponse,
  ApiTimeTrackingStampsPostData,
  ApiTimeTrackingStampsPostResponse,
  ApiTimeTrackingStampsPostError,
  ApiTimeTrackingStampsIdDeleteData,
  ApiTimeTrackingStampsIdDeleteResponse,
  ApiTimeTrackingStampsIdDeleteError,
  ApiTimeTrackingStampsIdGetData,
  ApiTimeTrackingStampsIdGetResponse,
  ApiTimeTrackingStampsIdGetError,
  ApiTimeTrackingStampsIdPutData,
  ApiTimeTrackingStampsIdPutResponse,
  ApiTimeTrackingStampsIdPutError,
  ApiTodoEntriesGetCollectionData,
  ApiTodoEntriesGetCollectionResponse,
  ApiTodoEntriesPostData,
  ApiTodoEntriesPostResponse,
  ApiTodoEntriesPostError,
  ApiTodoEntriesIdDeleteData,
  ApiTodoEntriesIdDeleteResponse,
  ApiTodoEntriesIdDeleteError,
  ApiTodoEntriesIdGetData,
  ApiTodoEntriesIdGetResponse,
  ApiTodoEntriesIdGetError,
  ApiTodoEntriesIdPutData,
  ApiTodoEntriesIdPutResponse,
  ApiTodoEntriesIdPutError,
  TfaDisableData,
  TfaDisableResponse,
  TfaDisableError,
  TfaDisableVerifyData,
  TfaDisableVerifyResponse,
  TfaDisableVerifyError,
  TfaSetupData,
  TfaSetupResponse,
  TfaSetupError,
  TfaSetupVerifyData,
  TfaSetupVerifyResponse,
  TfaSetupVerifyError,
  ApiUploadsGetCollectionData,
  ApiUploadsGetCollectionResponse,
  ApiUploadsPostData,
  ApiUploadsPostResponse,
  ApiUploadsPostError,
  ApiUploadsIdDeleteData,
  ApiUploadsIdDeleteResponse,
  ApiUploadsIdDeleteError,
  ApiUploadsIdGetData,
  ApiUploadsIdGetResponse,
  ApiUploadsIdGetError,
  ApiUploadsIdPutData,
  ApiUploadsIdPutResponse,
  ApiUploadsIdPutError,
  ApiUserUploadsGetCollectionData,
  ApiUserUploadsGetCollectionResponse,
  ApiUserUploadsPostData,
  ApiUserUploadsPostResponse,
  ApiUserUploadsPostError,
  ApiUserUploadsIdDeleteData,
  ApiUserUploadsIdDeleteResponse,
  ApiUserUploadsIdDeleteError,
  ApiUserUploadsIdGetData,
  ApiUserUploadsIdGetResponse,
  ApiUserUploadsIdGetError,
  ApiUserUploadsIdPutData,
  ApiUserUploadsIdPutResponse,
  ApiUserUploadsIdPutError,
  PostWebauthLoginOptionsData,
  PostWebauthLoginOptionsResponse,
  PostWebauthLoginOptionsError,
  PostWebauthLoginResultData,
  PostWebauthLoginResultResponse,
  PostWebauthLoginResultError,
  PostWebauthRegisterOptionsData,
  PostWebauthRegisterOptionsResponse,
  PostWebauthRegisterOptionsError,
  PostWebauthRegisterResultData,
  PostWebauthRegisterResultResponse,
  PostWebauthRegisterResultError,
  ApiWebauthPasskeysIdDeleteData,
  ApiWebauthPasskeysIdDeleteResponse,
  ApiWebauthPasskeysIdDeleteError,
  ApiWebauthPasskeysIdPutData,
  ApiWebauthPasskeysIdPutResponse,
  ApiWebauthPasskeysIdPutError,
  ApiWebauthPasskeysEmployeeGetData,
  ApiWebauthPasskeysEmployeeGetResponse,
  ApiWebauthPasskeysEmployeeGetError,
  ApiWhistleblowsGetCollectionData,
  ApiWhistleblowsGetCollectionResponse,
  ApiWhistleblowsGetCollectionError,
  ApiWhistleblowsPostData,
  ApiWhistleblowsPostResponse,
  ApiWhistleblowsPostError,
  ApiWhistleblowsIdAccessCodeGetData,
  ApiWhistleblowsIdAccessCodeGetResponse,
  ApiWhistleblowsIdAccessCodeGetError,
  ApiWhistleblowMessagesPostData,
  ApiWhistleblowMessagesPostResponse,
  ApiWhistleblowMessagesPostError,
  WhoamiData,
  WhoamiResponse,
  WhoamiError,
  ApiWorktimeTrackingDaysGetCollectionData,
  ApiWorktimeTrackingDaysGetCollectionResponse,
  ApiWorktimeTrackingDaysPostData,
  ApiWorktimeTrackingDaysPostResponse,
  ApiWorktimeTrackingDaysPostError,
  ApiWorktimeTrackingDaysIdDeleteData,
  ApiWorktimeTrackingDaysIdDeleteResponse,
  ApiWorktimeTrackingDaysIdDeleteError,
  ApiWorktimeTrackingDaysIdGetData,
  ApiWorktimeTrackingDaysIdGetResponse,
  ApiWorktimeTrackingDaysIdGetError,
  ApiWorktimeTrackingDaysIdPutData,
  ApiWorktimeTrackingDaysIdPutResponse,
  ApiWorktimeTrackingDaysIdPutError,
  ApiWorktimeTrackingDayVersionsGetCollectionData,
  ApiWorktimeTrackingDayVersionsGetCollectionResponse,
  ApiWorktimeTrackingDayVersionsPostData,
  ApiWorktimeTrackingDayVersionsPostResponse,
  ApiWorktimeTrackingDayVersionsPostError,
  ApiWorktimeTrackingDayVersionsIdDeleteData,
  ApiWorktimeTrackingDayVersionsIdDeleteResponse,
  ApiWorktimeTrackingDayVersionsIdDeleteError,
  ApiWorktimeTrackingDayVersionsIdGetData,
  ApiWorktimeTrackingDayVersionsIdGetResponse,
  ApiWorktimeTrackingDayVersionsIdGetError,
  ApiWorktimeTrackingDayVersionsIdPutData,
  ApiWorktimeTrackingDayVersionsIdPutResponse,
  ApiWorktimeTrackingDayVersionsIdPutError,
  ApiWorktimetrackingentryproposalPostData,
  ApiWorktimetrackingentryproposalPostResponse,
  ApiWorktimetrackingentryproposalPostError,
  ApiWorktimeTrackingRelevancesEmployeeDateGetData,
  ApiWorktimeTrackingRelevancesEmployeeDateGetResponse,
  ApiWorktimeTrackingRelevancesEmployeeDateGetError,
  ApiWorktimeTrackingSummaryGetData,
  ApiWorktimeTrackingSummaryGetResponse,
  ApiWorktimeTrackingSummaryGetError,
  ApiWorktimeTrackingSummaryPostData,
  ApiWorktimeTrackingSummaryPostResponse,
  ApiWorktimeTrackingSummaryEmpIdGetData,
  ApiWorktimeTrackingSummaryEmpIdGetResponse,
  ApiWorktimeTrackingSummaryEmpIdGetError
} from './types.gen'
import { client as _heyApiClient } from './client.gen'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Optimize effort entry note
 * Creates a AI resource.
 */
export const apiAioptimizeEffortEntryNotePost = <ThrowOnError extends boolean = false>(options: Options<ApiAioptimizeEffortEntryNotePostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiAioptimizeEffortEntryNotePostResponse, ApiAioptimizeEffortEntryNotePostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/ai/optimize_effort_entry_note',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Activity resources.
 * Retrieves the collection of Activity resources.
 */
export const apiActivitiesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiActivitiesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiActivitiesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/activities',
    ...options
  })
}

/**
 * Creates a Activity resource.
 * Creates a Activity resource.
 */
export const apiActivitiesPost = <ThrowOnError extends boolean = false>(options: Options<ApiActivitiesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiActivitiesPostResponse, ApiActivitiesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/activities',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Activity resource.
 * Removes the Activity resource.
 */
export const apiActivitiesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiActivitiesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiActivitiesIdDeleteResponse, ApiActivitiesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/activities/{id}',
    ...options
  })
}

/**
 * Retrieves a Activity resource.
 * Retrieves a Activity resource.
 */
export const apiActivitiesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiActivitiesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiActivitiesIdGetResponse, ApiActivitiesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/activities/{id}',
    ...options
  })
}

/**
 * Replaces the Activity resource.
 * Replaces the Activity resource.
 */
export const apiActivitiesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiActivitiesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiActivitiesIdPutResponse, ApiActivitiesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/activities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Gibt die Admin-URL zurück
 * Diese Operation liefert eine spezielle URL für das Admin-Panel.
 */
export const adminUrl = <ThrowOnError extends boolean = false>(options: Options<AdminUrlData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<AdminUrlResponse, AdminUrlError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/other/admin_url',
    ...options
  })
}

/**
 * Gibt mehrere Admin-URLs zurück
 * Diese Operation liefert spezielle URLs für das Admin-Panel.
 */
export const adminUrlMulti = <ThrowOnError extends boolean = false>(options: Options<AdminUrlMultiData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<AdminUrlMultiResponse, AdminUrlMultiError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/other/admin_url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Announcement resources.
 * Retrieves the collection of Announcement resources.
 */
export const apiAnnouncementsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiAnnouncementsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiAnnouncementsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/announcements',
    ...options
  })
}

/**
 * Creates a Announcement resource.
 * Creates a Announcement resource.
 */
export const apiAnnouncementsPost = <ThrowOnError extends boolean = false>(options: Options<ApiAnnouncementsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiAnnouncementsPostResponse, ApiAnnouncementsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/announcements',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Announcement resource.
 * Removes the Announcement resource.
 */
export const apiAnnouncementsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiAnnouncementsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiAnnouncementsIdDeleteResponse, ApiAnnouncementsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/announcements/{id}',
    ...options
  })
}

/**
 * Retrieves a Announcement resource.
 * Retrieves a Announcement resource.
 */
export const apiAnnouncementsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiAnnouncementsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiAnnouncementsIdGetResponse, ApiAnnouncementsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/announcements/{id}',
    ...options
  })
}

/**
 * Replaces the Announcement resource.
 * Replaces the Announcement resource.
 */
export const apiAnnouncementsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiAnnouncementsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiAnnouncementsIdPutResponse, ApiAnnouncementsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/announcements/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Attachment resources.
 * Retrieves the collection of Attachment resources.
 */
export const apiAttachmentsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiAttachmentsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiAttachmentsGetCollectionResponse, ApiAttachmentsGetCollectionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/attachments',
    ...options
  })
}

/**
 * Creates a Attachment resource.
 * Creates a Attachment resource.
 */
export const apiAttachmentsPost = <ThrowOnError extends boolean = false>(options: Options<ApiAttachmentsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiAttachmentsPostResponse, ApiAttachmentsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/attachments',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Attachment resource.
 * Removes the Attachment resource.
 */
export const apiAttachmentsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiAttachmentsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiAttachmentsIdDeleteResponse, ApiAttachmentsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/attachments/{id}',
    ...options
  })
}

/**
 * Retrieves a Attachment resource.
 * Retrieves a Attachment resource.
 */
export const apiAttachmentsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiAttachmentsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiAttachmentsIdGetResponse, ApiAttachmentsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/attachments/{id}',
    ...options
  })
}

/**
 * Replaces the Attachment resource.
 * Replaces the Attachment resource.
 */
export const apiAttachmentsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiAttachmentsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiAttachmentsIdPutResponse, ApiAttachmentsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/attachments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of BusinessPartner resources.
 * Retrieves the collection of BusinessPartner resources.
 */
export const apiBusinessPartnersGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiBusinessPartnersGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiBusinessPartnersGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/business_partners',
    ...options
  })
}

/**
 * Creates a BusinessPartner resource.
 * Creates a BusinessPartner resource.
 */
export const apiBusinessPartnersPost = <ThrowOnError extends boolean = false>(options: Options<ApiBusinessPartnersPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiBusinessPartnersPostResponse, ApiBusinessPartnersPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/business_partners',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of BusinessPartner resources.
 * Retrieves the collection of BusinessPartner resources.
 */
export const businessPartnersShort = <ThrowOnError extends boolean = false>(options?: Options<BusinessPartnersShortData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/business_partners/short',
    ...options
  })
}

/**
 * Retrieves a BusinessPartner resource.
 * Retrieves a BusinessPartner resource.
 */
export const apiBusinessPartnersCodeGet = <ThrowOnError extends boolean = false>(options: Options<ApiBusinessPartnersCodeGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiBusinessPartnersCodeGetResponse, ApiBusinessPartnersCodeGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/business_partners/{code}',
    ...options
  })
}

/**
 * Replaces the BusinessPartner resource.
 * Replaces the BusinessPartner resource.
 */
export const apiBusinessPartnersCodePut = <ThrowOnError extends boolean = false>(options: Options<ApiBusinessPartnersCodePutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiBusinessPartnersCodePutResponse, ApiBusinessPartnersCodePutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/business_partners/{code}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a BusinessPartnerCredential resource.
 * Creates a BusinessPartnerCredential resource.
 */
export const apiBusinessPartnerCredentialsPost = <ThrowOnError extends boolean = false>(options: Options<ApiBusinessPartnerCredentialsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiBusinessPartnerCredentialsPostResponse, ApiBusinessPartnerCredentialsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/business_partner_credentials',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a BusinessPartnerCredentialUpdate resource.
 * Creates a BusinessPartnerCredentialUpdate resource.
 */
export const apiBusinessPartnerCredentialUpdatesPost = <ThrowOnError extends boolean = false>(options: Options<ApiBusinessPartnerCredentialUpdatesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiBusinessPartnerCredentialUpdatesPostResponse, ApiBusinessPartnerCredentialUpdatesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/business_partner_credential_updates',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a BusinessPartnerEvaluation resource.
 * Creates a BusinessPartnerEvaluation resource.
 */
export const apiBusinessPartnerEvaluationsPost = <ThrowOnError extends boolean = false>(options: Options<ApiBusinessPartnerEvaluationsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiBusinessPartnerEvaluationsPostResponse, ApiBusinessPartnerEvaluationsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/business_partner_evaluations',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a BusinessPartnerEvaluationUpdate resource.
 * Creates a BusinessPartnerEvaluationUpdate resource.
 */
export const apiBusinessPartnerEvaluationUpdatesPost = <ThrowOnError extends boolean = false>(options: Options<ApiBusinessPartnerEvaluationUpdatesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiBusinessPartnerEvaluationUpdatesPostResponse, ApiBusinessPartnerEvaluationUpdatesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/business_partner_evaluation_updates',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of CalendarEntry resources.
 * Retrieves the collection of CalendarEntry resources.
 */
export const apiCalendarEntriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiCalendarEntriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiCalendarEntriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entries',
    ...options
  })
}

/**
 * Creates a CalendarEntry resource.
 * Creates a CalendarEntry resource.
 */
export const apiCalendarEntriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEntriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiCalendarEntriesPostResponse, ApiCalendarEntriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entries',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the CalendarEntry resource.
 * Removes the CalendarEntry resource.
 */
export const apiCalendarEntriesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEntriesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiCalendarEntriesIdDeleteResponse, ApiCalendarEntriesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entries/{id}',
    ...options
  })
}

/**
 * Retrieves a CalendarEntry resource.
 * Retrieves a CalendarEntry resource.
 */
export const apiCalendarEntriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEntriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiCalendarEntriesIdGetResponse, ApiCalendarEntriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entries/{id}',
    ...options
  })
}

/**
 * Replaces the CalendarEntry resource.
 * Replaces the CalendarEntry resource.
 */
export const apiCalendarEntriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEntriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiCalendarEntriesIdPutResponse, ApiCalendarEntriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of CalendarEntryType resources.
 * Retrieves the collection of CalendarEntryType resources.
 */
export const apiCalendarEntryTypesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiCalendarEntryTypesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiCalendarEntryTypesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entry_types',
    ...options
  })
}

/**
 * Creates a CalendarEntryType resource.
 * Creates a CalendarEntryType resource.
 */
export const apiCalendarEntryTypesPost = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEntryTypesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiCalendarEntryTypesPostResponse, ApiCalendarEntryTypesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entry_types',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the CalendarEntryType resource.
 * Removes the CalendarEntryType resource.
 */
export const apiCalendarEntryTypesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEntryTypesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiCalendarEntryTypesIdDeleteResponse, ApiCalendarEntryTypesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entry_types/{id}',
    ...options
  })
}

/**
 * Retrieves a CalendarEntryType resource.
 * Retrieves a CalendarEntryType resource.
 */
export const apiCalendarEntryTypesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEntryTypesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiCalendarEntryTypesIdGetResponse, ApiCalendarEntryTypesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entry_types/{id}',
    ...options
  })
}

/**
 * Replaces the CalendarEntryType resource.
 * Replaces the CalendarEntryType resource.
 */
export const apiCalendarEntryTypesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEntryTypesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiCalendarEntryTypesIdPutResponse, ApiCalendarEntryTypesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_entry_types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of CalendarEvent resources.
 * Retrieves the collection of CalendarEvent resources.
 */
export const apiCalendarEventsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiCalendarEventsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiCalendarEventsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/calendar_events',
    ...options
  })
}

/**
 * Creates a CalendarEvent resource.
 * Creates a CalendarEvent resource.
 */
export const apiCalendarEventsPost = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEventsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiCalendarEventsPostResponse, ApiCalendarEventsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_events',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the CalendarEvent resource.
 * Removes the CalendarEvent resource.
 */
export const apiCalendarEventsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEventsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiCalendarEventsIdDeleteResponse, ApiCalendarEventsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_events/{id}',
    ...options
  })
}

/**
 * Retrieves a CalendarEvent resource.
 * Retrieves a CalendarEvent resource.
 */
export const apiCalendarEventsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEventsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiCalendarEventsIdGetResponse, ApiCalendarEventsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_events/{id}',
    ...options
  })
}

/**
 * Replaces the CalendarEvent resource.
 * Replaces the CalendarEvent resource.
 */
export const apiCalendarEventsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiCalendarEventsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiCalendarEventsIdPutResponse, ApiCalendarEventsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/calendar_events/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of CmsPage resources.
 * Retrieves the collection of CmsPage resources.
 */
export const apiCmsPagesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiCmsPagesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiCmsPagesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/cms_pages',
    ...options
  })
}

/**
 * Creates a CmsPage resource.
 * Creates a CmsPage resource.
 */
export const apiCmsPagesPost = <ThrowOnError extends boolean = false>(options: Options<ApiCmsPagesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiCmsPagesPostResponse, ApiCmsPagesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/cms_pages',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the CmsPage resource.
 * Removes the CmsPage resource.
 */
export const apiCmsPagesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiCmsPagesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiCmsPagesIdDeleteResponse, ApiCmsPagesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/cms_pages/{id}',
    ...options
  })
}

/**
 * Retrieves a CmsPage resource.
 * Retrieves a CmsPage resource.
 */
export const apiCmsPagesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiCmsPagesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiCmsPagesIdGetResponse, ApiCmsPagesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/cms_pages/{id}',
    ...options
  })
}

/**
 * Replaces the CmsPage resource.
 * Replaces the CmsPage resource.
 */
export const apiCmsPagesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiCmsPagesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiCmsPagesIdPutResponse, ApiCmsPagesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/cms_pages/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Config resources.
 * Retrieves the collection of Config resources.
 */
export const apiConfigsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiConfigsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiConfigsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/configs',
    ...options
  })
}

/**
 * Retrieves a Config resource.
 * Retrieves a Config resource.
 */
export const apiConfigsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiConfigsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiConfigsIdGetResponse, ApiConfigsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/configs/{id}',
    ...options
  })
}

/**
 * Replaces the Config resource.
 * Replaces the Config resource.
 */
export const apiConfigsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiConfigsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiConfigsIdPutResponse, ApiConfigsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/configs/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Contact resources.
 * Retrieves the collection of Contact resources.
 */
export const apiContactsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiContactsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiContactsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/contacts',
    ...options
  })
}

/**
 * Creates a Contact resource.
 * Creates a Contact resource.
 */
export const apiContactsPost = <ThrowOnError extends boolean = false>(options: Options<ApiContactsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiContactsPostResponse, ApiContactsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/contacts',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a Contact resource.
 * Retrieves a Contact resource.
 */
export const apiContactsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiContactsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiContactsIdGetResponse, ApiContactsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/contacts/{id}',
    ...options
  })
}

/**
 * Replaces the Contact resource.
 * Replaces the Contact resource.
 */
export const apiContactsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiContactsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiContactsIdPutResponse, ApiContactsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/contacts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of CronJobLog resources.
 * Retrieves the collection of CronJobLog resources.
 */
export const apiCronJobLogsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiCronJobLogsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiCronJobLogsGetCollectionResponse, ApiCronJobLogsGetCollectionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/cron_job_logs',
    ...options
  })
}

/**
 * Retrieves a CronJobLog resource.
 * Retrieves a CronJobLog resource.
 */
export const apiCronJobLogsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiCronJobLogsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiCronJobLogsIdGetResponse, ApiCronJobLogsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/cron_job_logs/{id}',
    ...options
  })
}

/**
 * Retrieves the collection of Dashboard resources.
 * Retrieves the collection of Dashboard resources.
 */
export const apiDashboardsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiDashboardsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiDashboardsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/dashboards',
    ...options
  })
}

/**
 * Creates a Dashboard resource.
 * Creates a Dashboard resource.
 */
export const apiDashboardsPost = <ThrowOnError extends boolean = false>(options: Options<ApiDashboardsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiDashboardsPostResponse, ApiDashboardsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/dashboards',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a Dashboard resource.
 * Retrieves a Dashboard resource.
 */
export const apiDashboardsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiDashboardsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiDashboardsIdGetResponse, ApiDashboardsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/dashboards/{id}',
    ...options
  })
}

/**
 * Replaces the Dashboard resource.
 * Replaces the Dashboard resource.
 */
export const apiDashboardsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiDashboardsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiDashboardsIdPutResponse, ApiDashboardsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/dashboards/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of DashboardWidget resources.
 * Retrieves the collection of DashboardWidget resources.
 */
export const apiDashboardWidgetsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiDashboardWidgetsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiDashboardWidgetsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/dashboard_widgets',
    ...options
  })
}

/**
 * Creates a DashboardWidget resource.
 * Creates a DashboardWidget resource.
 */
export const apiDashboardWidgetsPost = <ThrowOnError extends boolean = false>(options: Options<ApiDashboardWidgetsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiDashboardWidgetsPostResponse, ApiDashboardWidgetsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/dashboard_widgets',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the DashboardWidget resource.
 * Removes the DashboardWidget resource.
 */
export const apiDashboardWidgetsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiDashboardWidgetsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiDashboardWidgetsIdDeleteResponse, ApiDashboardWidgetsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/dashboard_widgets/{id}',
    ...options
  })
}

/**
 * Retrieves a DashboardWidget resource.
 * Retrieves a DashboardWidget resource.
 */
export const apiDashboardWidgetsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiDashboardWidgetsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiDashboardWidgetsIdGetResponse, ApiDashboardWidgetsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/dashboard_widgets/{id}',
    ...options
  })
}

/**
 * Replaces the DashboardWidget resource.
 * Replaces the DashboardWidget resource.
 */
export const apiDashboardWidgetsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiDashboardWidgetsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiDashboardWidgetsIdPutResponse, ApiDashboardWidgetsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/dashboard_widgets/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Department resources.
 * Retrieves the collection of Department resources.
 */
export const apiDepartmentsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiDepartmentsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiDepartmentsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/departments',
    ...options
  })
}

/**
 * Creates a Department resource.
 * Creates a Department resource.
 */
export const apiDepartmentsPost = <ThrowOnError extends boolean = false>(options: Options<ApiDepartmentsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiDepartmentsPostResponse, ApiDepartmentsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/departments',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a Department resource.
 * Retrieves a Department resource.
 */
export const apiDepartmentsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiDepartmentsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiDepartmentsIdGetResponse, ApiDepartmentsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/departments/{id}',
    ...options
  })
}

/**
 * Replaces the Department resource.
 * Replaces the Department resource.
 */
export const apiDepartmentsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiDepartmentsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiDepartmentsIdPutResponse, ApiDepartmentsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/departments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const apiEffortsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts',
    ...options
  })
}

/**
 * Creates a Effort resource.
 * Creates a Effort resource.
 */
export const apiEffortsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortsPostResponse, ApiEffortsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/efforts',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Effort resource.
 * Removes the Effort resource.
 */
export const apiEffortsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortsIdDeleteResponse, ApiEffortsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/efforts/{id}',
    ...options
  })
}

/**
 * Retrieves a Effort resource.
 * Retrieves a Effort resource.
 */
export const apiEffortsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortsIdGetResponse, ApiEffortsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/efforts/{id}',
    ...options
  })
}

/**
 * Replaces the Effort resource.
 * Replaces the Effort resource.
 */
export const apiEffortsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortsIdPutResponse, ApiEffortsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/efforts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const apiEffortsIdchildrenGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiEffortsIdchildrenGetCollectionData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortsIdchildrenGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts/{id}/children',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const effortPropertiesFast = <ThrowOnError extends boolean = false>(options: Options<EffortPropertiesFastData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<EffortPropertiesFastResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts/{id}/properties',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const effortsExtended = <ThrowOnError extends boolean = false>(options?: Options<EffortsExtendedData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<EffortsExtendedResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts_extended',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const apiEffortsLastUsedGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortsLastUsedGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortsLastUsedGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts_last_used',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const apiEffortsLostBudgetGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortsLostBudgetGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortsLostBudgetGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts_lost_budget',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const apiEffortsMyAssignmentsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortsMyAssignmentsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortsMyAssignmentsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts_my_assignments',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const apiEffortsMyPriorizedGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortsMyPriorizedGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortsMyPriorizedGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts_my_priorized',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const apiEffortsPriorizedGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortsPriorizedGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortsPriorizedGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts_priorized',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const effortsShort = <ThrowOnError extends boolean = false>(options?: Options<EffortsShortData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<EffortsShortResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts_short',
    ...options
  })
}

/**
 * Retrieves the collection of Effort resources.
 * Retrieves the collection of Effort resources.
 */
export const apiEffortsUnsyncedGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortsUnsyncedGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortsUnsyncedGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/efforts_unsynced',
    ...options
  })
}

/**
 * Retrieves the collection of EffortBucket resources.
 * Retrieves the collection of EffortBucket resources.
 */
export const apiEffortBucketsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortBucketsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortBucketsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_buckets',
    ...options
  })
}

/**
 * Creates a EffortBucket resource.
 * Creates a EffortBucket resource.
 */
export const apiEffortBucketsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortBucketsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortBucketsPostResponse, ApiEffortBucketsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_buckets',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortBucket resource.
 * Removes the EffortBucket resource.
 */
export const apiEffortBucketsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortBucketsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortBucketsIdDeleteResponse, ApiEffortBucketsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_buckets/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortBucket resource.
 * Retrieves a EffortBucket resource.
 */
export const apiEffortBucketsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortBucketsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortBucketsIdGetResponse, ApiEffortBucketsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_buckets/{id}',
    ...options
  })
}

/**
 * Replaces the EffortBucket resource.
 * Replaces the EffortBucket resource.
 */
export const apiEffortBucketsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortBucketsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortBucketsIdPutResponse, ApiEffortBucketsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_buckets/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortChannel resources.
 * Retrieves the collection of EffortChannel resources.
 */
export const apiEffortChannelsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortChannelsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortChannelsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_channels',
    ...options
  })
}

/**
 * Creates a EffortChannel resource.
 * Creates a EffortChannel resource.
 */
export const apiEffortChannelsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortChannelsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortChannelsPostResponse, ApiEffortChannelsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_channels',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortChannel resource.
 * Removes the EffortChannel resource.
 */
export const apiEffortChannelsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortChannelsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortChannelsIdDeleteResponse, ApiEffortChannelsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_channels/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortChannel resource.
 * Retrieves a EffortChannel resource.
 */
export const apiEffortChannelsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortChannelsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortChannelsIdGetResponse, ApiEffortChannelsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_channels/{id}',
    ...options
  })
}

/**
 * Replaces the EffortChannel resource.
 * Replaces the EffortChannel resource.
 */
export const apiEffortChannelsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortChannelsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortChannelsIdPutResponse, ApiEffortChannelsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_channels/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortChannelItem resources.
 * Retrieves the collection of EffortChannelItem resources.
 */
export const apiEffortChannelItemsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortChannelItemsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortChannelItemsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_channel_items',
    ...options
  })
}

/**
 * Creates a EffortChannelItem resource.
 * Creates a EffortChannelItem resource.
 */
export const apiEffortChannelItemsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortChannelItemsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortChannelItemsPostResponse, ApiEffortChannelItemsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_channel_items',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortChannelItem resource.
 * Removes the EffortChannelItem resource.
 */
export const apiEffortChannelItemsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortChannelItemsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortChannelItemsIdDeleteResponse, ApiEffortChannelItemsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_channel_items/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortChannelItem resource.
 * Retrieves a EffortChannelItem resource.
 */
export const apiEffortChannelItemsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortChannelItemsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortChannelItemsIdGetResponse, ApiEffortChannelItemsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_channel_items/{id}',
    ...options
  })
}

/**
 * Replaces the EffortChannelItem resource.
 * Replaces the EffortChannelItem resource.
 */
export const apiEffortChannelItemsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortChannelItemsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortChannelItemsIdPutResponse, ApiEffortChannelItemsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_channel_items/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortDriving resources.
 * Retrieves the collection of EffortDriving resources.
 */
export const apiEffortDrivingsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortDrivingsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortDrivingsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_drivings',
    ...options
  })
}

/**
 * Creates a EffortDriving resource.
 * Creates a EffortDriving resource.
 */
export const apiEffortDrivingsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortDrivingsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortDrivingsPostResponse, ApiEffortDrivingsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_drivings',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortDriving resource.
 * Removes the EffortDriving resource.
 */
export const apiEffortDrivingsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortDrivingsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortDrivingsIdDeleteResponse, ApiEffortDrivingsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_drivings/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortDriving resource.
 * Retrieves a EffortDriving resource.
 */
export const apiEffortDrivingsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortDrivingsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortDrivingsIdGetResponse, ApiEffortDrivingsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_drivings/{id}',
    ...options
  })
}

/**
 * Replaces the EffortDriving resource.
 * Replaces the EffortDriving resource.
 */
export const apiEffortDrivingsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortDrivingsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortDrivingsIdPutResponse, ApiEffortDrivingsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_drivings/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortEntry resources.
 * Retrieves the collection of EffortEntry resources.
 */
export const apiEffortEntriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortEntriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortEntriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_entries',
    ...options
  })
}

/**
 * Creates a EffortEntry resource.
 * Creates a EffortEntry resource.
 */
export const apiEffortEntriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortEntriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortEntriesPostResponse, ApiEffortEntriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_entries',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortEntry resource.
 * Removes the EffortEntry resource.
 */
export const apiEffortEntriesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortEntriesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortEntriesIdDeleteResponse, ApiEffortEntriesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_entries/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortEntry resource.
 * Retrieves a EffortEntry resource.
 */
export const apiEffortEntriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortEntriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortEntriesIdGetResponse, ApiEffortEntriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_entries/{id}',
    ...options
  })
}

/**
 * Replaces the EffortEntry resource.
 * Replaces the EffortEntry resource.
 */
export const apiEffortEntriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortEntriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortEntriesIdPutResponse, ApiEffortEntriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_entries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortEntry resources.
 * Retrieves the collection of EffortEntry resources.
 */
export const apiEffortEntriesByPartnerPartnerGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiEffortEntriesByPartnerPartnerGetCollectionData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortEntriesByPartnerPartnerGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_entries_by_partner/{partner}',
    ...options
  })
}

/**
 * Retrieves the collection of EffortEntry resources.
 * Retrieves the collection of EffortEntry resources.
 */
export const apiEffortEntriesRecursiveEffortidGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiEffortEntriesRecursiveEffortidGetCollectionData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortEntriesRecursiveEffortidGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_entries_recursive/{effortid}',
    ...options
  })
}

/**
 * Retrieves the collection of EffortEntry resources.
 * Retrieves the collection of EffortEntry resources.
 */
export const apiEffortEntriesShortGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortEntriesShortGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortEntriesShortGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_entries_short',
    ...options
  })
}

/**
 * Retrieves the collection of EffortEntry resources.
 * Retrieves the collection of EffortEntry resources.
 */
export const apiEffortEntriesUnsyncedGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortEntriesUnsyncedGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortEntriesUnsyncedGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_entries_unsynced',
    ...options
  })
}

/**
 * Retrieves the collection of EffortExpense resources.
 * Retrieves the collection of EffortExpense resources.
 */
export const apiEffortExpensesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortExpensesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortExpensesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_expenses',
    ...options
  })
}

/**
 * Creates a EffortExpense resource.
 * Creates a EffortExpense resource.
 */
export const apiEffortExpensesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortExpensesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortExpensesPostResponse, ApiEffortExpensesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_expenses',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortExpense resource.
 * Removes the EffortExpense resource.
 */
export const apiEffortExpensesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortExpensesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortExpensesIdDeleteResponse, ApiEffortExpensesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_expenses/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortExpense resource.
 * Retrieves a EffortExpense resource.
 */
export const apiEffortExpensesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortExpensesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortExpensesIdGetResponse, ApiEffortExpensesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_expenses/{id}',
    ...options
  })
}

/**
 * Replaces the EffortExpense resource.
 * Replaces the EffortExpense resource.
 */
export const apiEffortExpensesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortExpensesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortExpensesIdPutResponse, ApiEffortExpensesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_expenses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a EffortExpense resource.
 * Creates a EffortExpense resource.
 */
export const apiEffortExpensesIdattachmentPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortExpensesIdattachmentPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortExpensesIdattachmentPostResponse, ApiEffortExpensesIdattachmentPostError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_expenses/{id}/attachment',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortLink resources.
 * Retrieves the collection of EffortLink resources.
 */
export const apiEffortLinksGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortLinksGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortLinksGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_links',
    ...options
  })
}

/**
 * Creates a EffortLink resource.
 * Creates a EffortLink resource.
 */
export const apiEffortLinksPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortLinksPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortLinksPostResponse, ApiEffortLinksPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_links',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortLink resource.
 * Removes the EffortLink resource.
 */
export const apiEffortLinksIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortLinksIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortLinksIdDeleteResponse, ApiEffortLinksIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_links/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortLink resource.
 * Retrieves a EffortLink resource.
 */
export const apiEffortLinksIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortLinksIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortLinksIdGetResponse, ApiEffortLinksIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_links/{id}',
    ...options
  })
}

/**
 * Replaces the EffortLink resource.
 * Replaces the EffortLink resource.
 */
export const apiEffortLinksIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortLinksIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortLinksIdPutResponse, ApiEffortLinksIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_links/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortMember resources.
 * Retrieves the collection of EffortMember resources.
 */
export const apiEffortMembersGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortMembersGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortMembersGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_members',
    ...options
  })
}

/**
 * Creates a EffortMember resource.
 * Creates a EffortMember resource.
 */
export const apiEffortMembersPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortMembersPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortMembersPostResponse, ApiEffortMembersPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_members',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortMember resource.
 * Removes the EffortMember resource.
 */
export const apiEffortMembersIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortMembersIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortMembersIdDeleteResponse, ApiEffortMembersIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_members/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortMember resource.
 * Retrieves a EffortMember resource.
 */
export const apiEffortMembersIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortMembersIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortMembersIdGetResponse, ApiEffortMembersIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_members/{id}',
    ...options
  })
}

/**
 * Replaces the EffortMember resource.
 * Replaces the EffortMember resource.
 */
export const apiEffortMembersIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortMembersIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortMembersIdPutResponse, ApiEffortMembersIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_members/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortNote resources.
 * Retrieves the collection of EffortNote resources.
 */
export const apiEffortNotesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortNotesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortNotesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_notes',
    ...options
  })
}

/**
 * Creates a EffortNote resource.
 * Creates a EffortNote resource.
 */
export const apiEffortNotesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortNotesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortNotesPostResponse, ApiEffortNotesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_notes',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortNote resource.
 * Removes the EffortNote resource.
 */
export const apiEffortNotesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortNotesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortNotesIdDeleteResponse, ApiEffortNotesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_notes/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortNote resource.
 * Retrieves a EffortNote resource.
 */
export const apiEffortNotesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortNotesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortNotesIdGetResponse, ApiEffortNotesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_notes/{id}',
    ...options
  })
}

/**
 * Replaces the EffortNote resource.
 * Replaces the EffortNote resource.
 */
export const apiEffortNotesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortNotesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortNotesIdPutResponse, ApiEffortNotesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_notes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EffortOvernightStay resources.
 * Retrieves the collection of EffortOvernightStay resources.
 */
export const apiEffortOvernightStaysGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortOvernightStaysGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortOvernightStaysGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_overnight_stays',
    ...options
  })
}

/**
 * Creates a EffortOvernightStay resource.
 * Creates a EffortOvernightStay resource.
 */
export const apiEffortOvernightStaysPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortOvernightStaysPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortOvernightStaysPostResponse, ApiEffortOvernightStaysPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_overnight_stays',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortOvernightStay resource.
 * Removes the EffortOvernightStay resource.
 */
export const apiEffortOvernightStaysIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortOvernightStaysIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortOvernightStaysIdDeleteResponse, ApiEffortOvernightStaysIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_overnight_stays/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortOvernightStay resource.
 * Retrieves a EffortOvernightStay resource.
 */
export const apiEffortOvernightStaysIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortOvernightStaysIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortOvernightStaysIdGetResponse, ApiEffortOvernightStaysIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_overnight_stays/{id}',
    ...options
  })
}

/**
 * Replaces the EffortOvernightStay resource.
 * Replaces the EffortOvernightStay resource.
 */
export const apiEffortOvernightStaysIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortOvernightStaysIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortOvernightStaysIdPutResponse, ApiEffortOvernightStaysIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_overnight_stays/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a EffortOvernightStay resource.
 * Creates a EffortOvernightStay resource.
 */
export const apiEffortOvernightStaysIdattachmentPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortOvernightStaysIdattachmentPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortOvernightStaysIdattachmentPostResponse, ApiEffortOvernightStaysIdattachmentPostError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_overnight_stays/{id}/attachment',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers
    }
  })
}

/**
 * Creates a EffortProperty resource.
 * Creates a EffortProperty resource.
 */
export const apiEffortPropertiesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortPropertiesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortPropertiesPostResponse, ApiEffortPropertiesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_properties',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortProperty resource.
 * Removes the EffortProperty resource.
 */
export const apiEffortPropertiesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortPropertiesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortPropertiesIdDeleteResponse, ApiEffortPropertiesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_properties/{id}',
    ...options
  })
}

/**
 * Retrieves the collection of EffortState resources.
 * Retrieves the collection of EffortState resources.
 */
export const apiEffortStatesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortStatesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortStatesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_states',
    ...options
  })
}

/**
 * Creates a EffortState resource.
 * Creates a EffortState resource.
 */
export const apiEffortStatesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortStatesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortStatesPostResponse, ApiEffortStatesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_states',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortState resource.
 * Removes the EffortState resource.
 */
export const apiEffortStatesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortStatesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortStatesIdDeleteResponse, ApiEffortStatesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_states/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortState resource.
 * Retrieves a EffortState resource.
 */
export const apiEffortStatesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortStatesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortStatesIdGetResponse, ApiEffortStatesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_states/{id}',
    ...options
  })
}

/**
 * Replaces the EffortState resource.
 * Replaces the EffortState resource.
 */
export const apiEffortStatesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortStatesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortStatesIdPutResponse, ApiEffortStatesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_states/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a EffortTree resource.
 * Retrieves a EffortTree resource.
 */
export const apiEffortTreesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortTreesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortTreesIdGetResponse, ApiEffortTreesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_trees/{id}',
    ...options
  })
}

/**
 * Retrieves the collection of EffortType resources.
 * Retrieves the collection of EffortType resources.
 */
export const apiEffortTypesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEffortTypesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEffortTypesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/effort_types',
    ...options
  })
}

/**
 * Creates a EffortType resource.
 * Creates a EffortType resource.
 */
export const apiEffortTypesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEffortTypesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEffortTypesPostResponse, ApiEffortTypesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_types',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EffortType resource.
 * Removes the EffortType resource.
 */
export const apiEffortTypesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEffortTypesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEffortTypesIdDeleteResponse, ApiEffortTypesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_types/{id}',
    ...options
  })
}

/**
 * Retrieves a EffortType resource.
 * Retrieves a EffortType resource.
 */
export const apiEffortTypesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEffortTypesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEffortTypesIdGetResponse, ApiEffortTypesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_types/{id}',
    ...options
  })
}

/**
 * Replaces the EffortType resource.
 * Replaces the EffortType resource.
 */
export const apiEffortTypesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEffortTypesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEffortTypesIdPutResponse, ApiEffortTypesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/effort_types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a Employee resource.
 * Creates a Employee resource.
 */
export const apiAuth2FaverifyPost = <ThrowOnError extends boolean = false>(options: Options<ApiAuth2FaverifyPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiAuth2FaverifyPostResponse, ApiAuth2FaverifyPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/auth/2fa/verify',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Employee resources.
 * Retrieves the collection of Employee resources.
 */
export const apiEmployeesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employees',
    ...options
  })
}

/**
 * Creates a Employee resource.
 * Creates a Employee resource.
 */
export const apiEmployeesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeesPostResponse, ApiEmployeesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employees',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a Employee resource.
 * Retrieves a Employee resource.
 */
export const apiEmployeesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeesIdGetResponse, ApiEmployeesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employees/{id}',
    ...options
  })
}

/**
 * Replaces the Employee resource.
 * Replaces the Employee resource.
 */
export const apiEmployeesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeesIdPutResponse, ApiEmployeesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employees/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Employee resource.
 * Removes the Employee resource.
 */
export const apiEmployeesIdavatarDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeesIdavatarDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeesIdavatarDeleteResponse, ApiEmployeesIdavatarDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employees/{id}/avatar',
    ...options
  })
}

/**
 * Creates a Employee resource.
 * Creates a Employee resource.
 */
export const apiEmployeesIdavatarPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeesIdavatarPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeesIdavatarPostResponse, ApiEmployeesIdavatarPostError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employees/{id}/avatar',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers
    }
  })
}

/**
 * Creates a EmployeeApiToken resource.
 * Creates a EmployeeApiToken resource.
 */
export const apiEmployeeApiTokensPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeApiTokensPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeApiTokensPostResponse, ApiEmployeeApiTokensPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_api_tokens',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeApiToken resource.
 * Removes the EmployeeApiToken resource.
 */
export const apiEmployeeApiTokensIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeApiTokensIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeApiTokensIdDeleteResponse, ApiEmployeeApiTokensIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_api_tokens/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeApiToken resource.
 * Replaces the EmployeeApiToken resource.
 */
export const apiEmployeeApiTokensIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeApiTokensIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeApiTokensIdPutResponse, ApiEmployeeApiTokensIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_api_tokens/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeAvatar resources.
 * Retrieves the collection of EmployeeAvatar resources.
 */
export const apiEmployeeAvatarsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeAvatarsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeAvatarsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_avatars',
    ...options
  })
}

/**
 * Retrieves a EmployeeAvatar resource.
 * Retrieves a EmployeeAvatar resource.
 */
export const apiEmployeeAvatarsEmployeeGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeAvatarsEmployeeGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeAvatarsEmployeeGetResponse, ApiEmployeeAvatarsEmployeeGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_avatars/{employee}',
    ...options
  })
}

/**
 * Retrieves the collection of EmployeeBalance resources.
 * Retrieves the collection of EmployeeBalance resources.
 */
export const apiEmployeeBalancesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeBalancesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeBalancesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_balances',
    ...options
  })
}

/**
 * Creates a EmployeeBalance resource.
 * Creates a EmployeeBalance resource.
 */
export const apiEmployeeBalancesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeBalancesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeBalancesPostResponse, ApiEmployeeBalancesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_balances',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeBalance resource.
 * Removes the EmployeeBalance resource.
 */
export const apiEmployeeBalancesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeBalancesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeBalancesIdDeleteResponse, ApiEmployeeBalancesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_balances/{id}',
    ...options
  })
}

/**
 * Retrieves a EmployeeBalance resource.
 * Retrieves a EmployeeBalance resource.
 */
export const apiEmployeeBalancesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeBalancesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeBalancesIdGetResponse, ApiEmployeeBalancesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_balances/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeBalance resource.
 * Replaces the EmployeeBalance resource.
 */
export const apiEmployeeBalancesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeBalancesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeBalancesIdPutResponse, ApiEmployeeBalancesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_balances/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeConfig resources.
 * Retrieves the collection of EmployeeConfig resources.
 */
export const apiEmployeeConfigsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeConfigsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeConfigsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_configs',
    ...options
  })
}

/**
 * Creates a EmployeeConfig resource.
 * Creates a EmployeeConfig resource.
 */
export const apiEmployeeConfigsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeConfigsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeConfigsPostResponse, ApiEmployeeConfigsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_configs',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeConfig resource.
 * Removes the EmployeeConfig resource.
 */
export const apiEmployeeConfigsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeConfigsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeConfigsIdDeleteResponse, ApiEmployeeConfigsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_configs/{id}',
    ...options
  })
}

/**
 * Retrieves a EmployeeConfig resource.
 * Retrieves a EmployeeConfig resource.
 */
export const apiEmployeeConfigsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeConfigsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeConfigsIdGetResponse, ApiEmployeeConfigsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_configs/{id}',
    ...options
  })
}

/**
 * Retrieves the collection of EmployeeConfigDefault resources.
 * Retrieves the collection of EmployeeConfigDefault resources.
 */
export const apiEmployeeConfigDefaultsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeConfigDefaultsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeConfigDefaultsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employee_config_defaults',
    ...options
  })
}

/**
 * Creates a EmployeeConfigDefault resource.
 * Creates a EmployeeConfigDefault resource.
 */
export const apiEmployeeConfigDefaultsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeConfigDefaultsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeConfigDefaultsPostResponse, ApiEmployeeConfigDefaultsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_config_defaults',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a EmployeeConfigDefault resource.
 * Retrieves a EmployeeConfigDefault resource.
 */
export const apiEmployeeConfigDefaultsKeyGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeConfigDefaultsKeyGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeConfigDefaultsKeyGetResponse, ApiEmployeeConfigDefaultsKeyGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_config_defaults/{key}',
    ...options
  })
}

/**
 * Replaces the EmployeeConfigDefault resource.
 * Replaces the EmployeeConfigDefault resource.
 */
export const apiEmployeeConfigDefaultsKeyPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeConfigDefaultsKeyPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeConfigDefaultsKeyPutResponse, ApiEmployeeConfigDefaultsKeyPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_config_defaults/{key}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeFavorite resources.
 * Retrieves the collection of EmployeeFavorite resources.
 */
export const apiEmployeeFavoritesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeFavoritesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeFavoritesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employee_favorites',
    ...options
  })
}

/**
 * Creates a EmployeeFavorite resource.
 * Creates a EmployeeFavorite resource.
 */
export const apiEmployeeFavoritesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeFavoritesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeFavoritesPostResponse, ApiEmployeeFavoritesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_favorites',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeFavorite resource.
 * Removes the EmployeeFavorite resource.
 */
export const apiEmployeeFavoritesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeFavoritesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeFavoritesIdDeleteResponse, ApiEmployeeFavoritesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_favorites/{id}',
    ...options
  })
}

/**
 * Retrieves a EmployeeFavorite resource.
 * Retrieves a EmployeeFavorite resource.
 */
export const apiEmployeeFavoritesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeFavoritesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeFavoritesIdGetResponse, ApiEmployeeFavoritesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_favorites/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeFavorite resource.
 * Replaces the EmployeeFavorite resource.
 */
export const apiEmployeeFavoritesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeFavoritesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeFavoritesIdPutResponse, ApiEmployeeFavoritesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_favorites/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeHobby resources.
 * Retrieves the collection of EmployeeHobby resources.
 */
export const apiEmployeeHobbiesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeHobbiesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeHobbiesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_hobbies',
    ...options
  })
}

/**
 * Retrieves the collection of EmployeeMail resources.
 * Retrieves the collection of EmployeeMail resources.
 */
export const apiEmployeeMailsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeMailsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeMailsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employee_mails',
    ...options
  })
}

/**
 * Creates a EmployeeMail resource.
 * Creates a EmployeeMail resource.
 */
export const apiEmployeeMailsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeMailsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeMailsPostResponse, ApiEmployeeMailsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_mails',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeMail resource.
 * Removes the EmployeeMail resource.
 */
export const apiEmployeeMailsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeMailsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeMailsIdDeleteResponse, ApiEmployeeMailsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_mails/{id}',
    ...options
  })
}

/**
 * Retrieves a EmployeeMail resource.
 * Retrieves a EmployeeMail resource.
 */
export const apiEmployeeMailsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeMailsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeMailsIdGetResponse, ApiEmployeeMailsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_mails/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeMail resource.
 * Replaces the EmployeeMail resource.
 */
export const apiEmployeeMailsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeMailsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeMailsIdPutResponse, ApiEmployeeMailsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_mails/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeMailFolder resources.
 * Retrieves the collection of EmployeeMailFolder resources.
 */
export const apiEmployeeMailFoldersGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeMailFoldersGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeMailFoldersGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employee_mail_folders',
    ...options
  })
}

/**
 * Creates a EmployeeMailFolder resource.
 * Creates a EmployeeMailFolder resource.
 */
export const apiEmployeeMailFoldersPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeMailFoldersPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeMailFoldersPostResponse, ApiEmployeeMailFoldersPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_mail_folders',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeMailFolder resource.
 * Removes the EmployeeMailFolder resource.
 */
export const apiEmployeeMailFoldersIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeMailFoldersIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeMailFoldersIdDeleteResponse, ApiEmployeeMailFoldersIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_mail_folders/{id}',
    ...options
  })
}

/**
 * Retrieves a EmployeeMailFolder resource.
 * Retrieves a EmployeeMailFolder resource.
 */
export const apiEmployeeMailFoldersIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeMailFoldersIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeMailFoldersIdGetResponse, ApiEmployeeMailFoldersIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_mail_folders/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeMailFolder resource.
 * Replaces the EmployeeMailFolder resource.
 */
export const apiEmployeeMailFoldersIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeMailFoldersIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeMailFoldersIdPutResponse, ApiEmployeeMailFoldersIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_mail_folders/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeNotification resources.
 * Retrieves the collection of EmployeeNotification resources.
 */
export const apiEmployeeNotificationsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeNotificationsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeNotificationsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_notifications',
    ...options
  })
}

/**
 * Retrieves a EmployeeNotification resource.
 * Retrieves a EmployeeNotification resource.
 */
export const apiEmployeeNotificationsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeNotificationsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeNotificationsIdGetResponse, ApiEmployeeNotificationsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_notifications/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeNotification resource.
 * Replaces the EmployeeNotification resource.
 */
export const apiEmployeeNotificationsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeNotificationsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeNotificationsIdPutResponse, ApiEmployeeNotificationsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_notifications/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeNotificationSetting resources.
 * Retrieves the collection of EmployeeNotificationSetting resources.
 */
export const apiEmployeeNotificationSettingsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeNotificationSettingsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeNotificationSettingsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employee_notification_settings',
    ...options
  })
}

/**
 * Creates a EmployeeNotificationSetting resource.
 * Creates a EmployeeNotificationSetting resource.
 */
export const apiEmployeeNotificationSettingsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeNotificationSettingsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeNotificationSettingsPostResponse, ApiEmployeeNotificationSettingsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_notification_settings',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeNotificationSetting resource.
 * Removes the EmployeeNotificationSetting resource.
 */
export const apiEmployeeNotificationSettingsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeNotificationSettingsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeNotificationSettingsIdDeleteResponse, ApiEmployeeNotificationSettingsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_notification_settings/{id}',
    ...options
  })
}

/**
 * Retrieves a EmployeeNotificationSetting resource.
 * Retrieves a EmployeeNotificationSetting resource.
 */
export const apiEmployeeNotificationSettingsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeNotificationSettingsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeNotificationSettingsIdGetResponse, ApiEmployeeNotificationSettingsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_notification_settings/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeNotificationSetting resource.
 * Replaces the EmployeeNotificationSetting resource.
 */
export const apiEmployeeNotificationSettingsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeNotificationSettingsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeNotificationSettingsIdPutResponse, ApiEmployeeNotificationSettingsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_notification_settings/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a EmployeeProfile resource.
 * Retrieves a EmployeeProfile resource.
 */
export const apiEmployeeProfilesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeProfilesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeProfilesIdGetResponse, ApiEmployeeProfilesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_profiles/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeProfile resource.
 * Replaces the EmployeeProfile resource.
 */
export const apiEmployeeProfilesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeProfilesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeProfilesIdPutResponse, ApiEmployeeProfilesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_profiles/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeProgressiveSkill resources.
 * Retrieves the collection of EmployeeProgressiveSkill resources.
 */
export const apiEmployeeProgressiveSkillsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeProgressiveSkillsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeProgressiveSkillsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_progressive_skills',
    ...options
  })
}

/**
 * Retrieves the collection of EmployeeSkill resources.
 * Retrieves the collection of EmployeeSkill resources.
 */
export const apiEmployeeSkillsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeSkillsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeSkillsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_skills',
    ...options
  })
}

/**
 * Retrieves the collection of EmployeeState resources.
 * Retrieves the collection of EmployeeState resources.
 */
export const apiEmployeeStatesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeStatesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeStatesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employee_states',
    ...options
  })
}

/**
 * Creates a EmployeeState resource.
 * Creates a EmployeeState resource.
 */
export const apiEmployeeStatesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStatesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeStatesPostResponse, ApiEmployeeStatesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_states',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a EmployeeState resource.
 * Retrieves a EmployeeState resource.
 */
export const apiEmployeeStatesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStatesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeStatesIdGetResponse, ApiEmployeeStatesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_states/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeState resource.
 * Replaces the EmployeeState resource.
 */
export const apiEmployeeStatesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStatesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeStatesIdPutResponse, ApiEmployeeStatesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_states/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeStateHistory resources.
 * Retrieves the collection of EmployeeStateHistory resources.
 */
export const apiEmployeeStateHistoriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeStateHistoriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeStateHistoriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employee_state_histories',
    ...options
  })
}

/**
 * Creates a EmployeeStateHistory resource.
 * Creates a EmployeeStateHistory resource.
 */
export const apiEmployeeStateHistoriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStateHistoriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeStateHistoriesPostResponse, ApiEmployeeStateHistoriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_state_histories',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeStateHistory resource.
 * Removes the EmployeeStateHistory resource.
 */
export const apiEmployeeStateHistoriesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStateHistoriesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeStateHistoriesIdDeleteResponse, ApiEmployeeStateHistoriesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_state_histories/{id}',
    ...options
  })
}

/**
 * Retrieves a EmployeeStateHistory resource.
 * Retrieves a EmployeeStateHistory resource.
 */
export const apiEmployeeStateHistoriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStateHistoriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeStateHistoriesIdGetResponse, ApiEmployeeStateHistoriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_state_histories/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeStateHistory resource.
 * Replaces the EmployeeStateHistory resource.
 */
export const apiEmployeeStateHistoriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStateHistoriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeStateHistoriesIdPutResponse, ApiEmployeeStateHistoriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_state_histories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of EmployeeStateStamp resources.
 * Retrieves the collection of EmployeeStateStamp resources.
 */
export const apiEmployeeStateStampsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiEmployeeStateStampsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiEmployeeStateStampsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/employee_state_stamps',
    ...options
  })
}

/**
 * Creates a EmployeeStateStamp resource.
 * Creates a EmployeeStateStamp resource.
 */
export const apiEmployeeStateStampsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStateStampsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeStateStampsPostResponse, ApiEmployeeStateStampsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_state_stamps',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the EmployeeStateStamp resource.
 * Removes the EmployeeStateStamp resource.
 */
export const apiEmployeeStateStampsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStateStampsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiEmployeeStateStampsIdDeleteResponse, ApiEmployeeStateStampsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_state_stamps/{id}',
    ...options
  })
}

/**
 * Retrieves a EmployeeStateStamp resource.
 * Retrieves a EmployeeStateStamp resource.
 */
export const apiEmployeeStateStampsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStateStampsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiEmployeeStateStampsIdGetResponse, ApiEmployeeStateStampsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_state_stamps/{id}',
    ...options
  })
}

/**
 * Replaces the EmployeeStateStamp resource.
 * Replaces the EmployeeStateStamp resource.
 */
export const apiEmployeeStateStampsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeStateStampsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiEmployeeStateStampsIdPutResponse, ApiEmployeeStateStampsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_state_stamps/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a EmployeeSubscription resource.
 * Creates a EmployeeSubscription resource.
 */
export const apiEmployeeSubscriptionsPost = <ThrowOnError extends boolean = false>(options: Options<ApiEmployeeSubscriptionsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiEmployeeSubscriptionsPostResponse, ApiEmployeeSubscriptionsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/employee_subscriptions',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Throw a http error for testing
 * Throw a http error for testing
 */
export const errorTestGet = <ThrowOnError extends boolean = false>(options: Options<ErrorTestGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ErrorTestGetResponse, ErrorTestGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/error_test/{code}',
    ...options
  })
}

/**
 * Throw a http error for testing
 * Throw a http error for testing
 */
export const errorTestPost = <ThrowOnError extends boolean = false>(options: Options<ErrorTestPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ErrorTestPostResponse, ErrorTestPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/error_test/{code}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of ExpenseType resources.
 * Retrieves the collection of ExpenseType resources.
 */
export const apiExpenseTypesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiExpenseTypesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiExpenseTypesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/expense_types',
    ...options
  })
}

/**
 * Creates a ExpenseType resource.
 * Creates a ExpenseType resource.
 */
export const apiExpenseTypesPost = <ThrowOnError extends boolean = false>(options: Options<ApiExpenseTypesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiExpenseTypesPostResponse, ApiExpenseTypesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/expense_types',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a ExpenseType resource.
 * Retrieves a ExpenseType resource.
 */
export const apiExpenseTypesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiExpenseTypesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiExpenseTypesIdGetResponse, ApiExpenseTypesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/expense_types/{id}',
    ...options
  })
}

/**
 * Replaces the ExpenseType resource.
 * Replaces the ExpenseType resource.
 */
export const apiExpenseTypesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiExpenseTypesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiExpenseTypesIdPutResponse, ApiExpenseTypesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/expense_types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of FeatureFlag resources.
 * Retrieves the collection of FeatureFlag resources.
 */
export const apiFeatureFlagsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiFeatureFlagsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiFeatureFlagsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/feature_flags',
    ...options
  })
}

/**
 * Creates a FeatureFlag resource.
 * Creates a FeatureFlag resource.
 */
export const apiFeatureFlagsPost = <ThrowOnError extends boolean = false>(options: Options<ApiFeatureFlagsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiFeatureFlagsPostResponse, ApiFeatureFlagsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/feature_flags',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the FeatureFlag resource.
 * Removes the FeatureFlag resource.
 */
export const apiFeatureFlagsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiFeatureFlagsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiFeatureFlagsIdDeleteResponse, ApiFeatureFlagsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/feature_flags/{id}',
    ...options
  })
}

/**
 * Retrieves a FeatureFlag resource.
 * Retrieves a FeatureFlag resource.
 */
export const apiFeatureFlagsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiFeatureFlagsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiFeatureFlagsIdGetResponse, ApiFeatureFlagsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/feature_flags/{id}',
    ...options
  })
}

/**
 * Replaces the FeatureFlag resource.
 * Replaces the FeatureFlag resource.
 */
export const apiFeatureFlagsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiFeatureFlagsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiFeatureFlagsIdPutResponse, ApiFeatureFlagsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/feature_flags/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a FilterBuilder resource.
 * Creates a FilterBuilder resource.
 */
export const apiFilterBuildersPost = <ThrowOnError extends boolean = false>(options: Options<ApiFilterBuildersPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiFilterBuildersPostResponse, ApiFilterBuildersPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/filter_builders',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of GitlabAuthor resources.
 * Retrieves the collection of GitlabAuthor resources.
 */
export const apiGitlabAuthorsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiGitlabAuthorsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiGitlabAuthorsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_authors',
    ...options
  })
}

/**
 * Creates a GitlabAuthor resource.
 * Creates a GitlabAuthor resource.
 */
export const apiGitlabAuthorsPost = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabAuthorsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiGitlabAuthorsPostResponse, ApiGitlabAuthorsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_authors',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a GitlabAuthor resource.
 * Retrieves a GitlabAuthor resource.
 */
export const apiGitlabAuthorsTidGet = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabAuthorsTidGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiGitlabAuthorsTidGetResponse, ApiGitlabAuthorsTidGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_authors/{tid}',
    ...options
  })
}

/**
 * Updates the GitlabAuthor resource.
 * Updates the GitlabAuthor resource.
 */
export const apiGitlabAuthorsTidPatch = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabAuthorsTidPatchData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).patch<ApiGitlabAuthorsTidPatchResponse, ApiGitlabAuthorsTidPatchError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_authors/{tid}',
    ...options,
    headers: {
      'Content-Type': 'application/merge-patch+json',
      ...options?.headers
    }
  })
}

/**
 * Replaces the GitlabAuthor resource.
 * Replaces the GitlabAuthor resource.
 */
export const apiGitlabAuthorsTidPut = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabAuthorsTidPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiGitlabAuthorsTidPutResponse, ApiGitlabAuthorsTidPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_authors/{tid}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of GitlabCommit resources.
 * Retrieves the collection of GitlabCommit resources.
 */
export const apiGitlabCommitsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiGitlabCommitsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiGitlabCommitsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_commits',
    ...options
  })
}

/**
 * Creates a GitlabCommit resource.
 * Creates a GitlabCommit resource.
 */
export const apiGitlabCommitsPost = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabCommitsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiGitlabCommitsPostResponse, ApiGitlabCommitsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_commits',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a GitlabCommit resource.
 * Retrieves a GitlabCommit resource.
 */
export const apiGitlabCommitsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabCommitsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiGitlabCommitsIdGetResponse, ApiGitlabCommitsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_commits/{id}',
    ...options
  })
}

/**
 * Updates the GitlabCommit resource.
 * Updates the GitlabCommit resource.
 */
export const apiGitlabCommitsIdPatch = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabCommitsIdPatchData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).patch<ApiGitlabCommitsIdPatchResponse, ApiGitlabCommitsIdPatchError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_commits/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/merge-patch+json',
      ...options?.headers
    }
  })
}

/**
 * Replaces the GitlabCommit resource.
 * Replaces the GitlabCommit resource.
 */
export const apiGitlabCommitsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabCommitsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiGitlabCommitsIdPutResponse, ApiGitlabCommitsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_commits/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of GitlabProject resources.
 * Retrieves the collection of GitlabProject resources.
 */
export const apiGitlabProjectsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiGitlabProjectsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiGitlabProjectsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_projects',
    ...options
  })
}

/**
 * Creates a GitlabProject resource.
 * Creates a GitlabProject resource.
 */
export const apiGitlabProjectsPost = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabProjectsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiGitlabProjectsPostResponse, ApiGitlabProjectsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_projects',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a GitlabProject resource.
 * Retrieves a GitlabProject resource.
 */
export const apiGitlabProjectsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabProjectsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiGitlabProjectsIdGetResponse, ApiGitlabProjectsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_projects/{id}',
    ...options
  })
}

/**
 * Updates the GitlabProject resource.
 * Updates the GitlabProject resource.
 */
export const apiGitlabProjectsIdPatch = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabProjectsIdPatchData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).patch<ApiGitlabProjectsIdPatchResponse, ApiGitlabProjectsIdPatchError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_projects/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/merge-patch+json',
      ...options?.headers
    }
  })
}

/**
 * Replaces the GitlabProject resource.
 * Replaces the GitlabProject resource.
 */
export const apiGitlabProjectsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabProjectsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiGitlabProjectsIdPutResponse, ApiGitlabProjectsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_projects/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of GitlabPush resources.
 * Retrieves the collection of GitlabPush resources.
 */
export const apiGitlabPushesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiGitlabPushesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiGitlabPushesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_pushes',
    ...options
  })
}

/**
 * Creates a GitlabPush resource.
 * Creates a GitlabPush resource.
 */
export const apiGitlabPushesPost = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabPushesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiGitlabPushesPostResponse, ApiGitlabPushesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_pushes',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a GitlabPush resource.
 * Retrieves a GitlabPush resource.
 */
export const apiGitlabPushesTidGet = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabPushesTidGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiGitlabPushesTidGetResponse, ApiGitlabPushesTidGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_pushes/{tid}',
    ...options
  })
}

/**
 * Updates the GitlabPush resource.
 * Updates the GitlabPush resource.
 */
export const apiGitlabPushesTidPatch = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabPushesTidPatchData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).patch<ApiGitlabPushesTidPatchResponse, ApiGitlabPushesTidPatchError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_pushes/{tid}',
    ...options,
    headers: {
      'Content-Type': 'application/merge-patch+json',
      ...options?.headers
    }
  })
}

/**
 * Replaces the GitlabPush resource.
 * Replaces the GitlabPush resource.
 */
export const apiGitlabPushesTidPut = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabPushesTidPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiGitlabPushesTidPutResponse, ApiGitlabPushesTidPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_pushes/{tid}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of GitlabRepository resources.
 * Retrieves the collection of GitlabRepository resources.
 */
export const apiGitlabRepositoriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiGitlabRepositoriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiGitlabRepositoriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_repositories',
    ...options
  })
}

/**
 * Creates a GitlabRepository resource.
 * Creates a GitlabRepository resource.
 */
export const apiGitlabRepositoriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabRepositoriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiGitlabRepositoriesPostResponse, ApiGitlabRepositoriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_repositories',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a GitlabRepository resource.
 * Retrieves a GitlabRepository resource.
 */
export const apiGitlabRepositoriesTidGet = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabRepositoriesTidGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiGitlabRepositoriesTidGetResponse, ApiGitlabRepositoriesTidGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_repositories/{tid}',
    ...options
  })
}

/**
 * Updates the GitlabRepository resource.
 * Updates the GitlabRepository resource.
 */
export const apiGitlabRepositoriesTidPatch = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabRepositoriesTidPatchData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).patch<ApiGitlabRepositoriesTidPatchResponse, ApiGitlabRepositoriesTidPatchError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_repositories/{tid}',
    ...options,
    headers: {
      'Content-Type': 'application/merge-patch+json',
      ...options?.headers
    }
  })
}

/**
 * Replaces the GitlabRepository resource.
 * Replaces the GitlabRepository resource.
 */
export const apiGitlabRepositoriesTidPut = <ThrowOnError extends boolean = false>(options: Options<ApiGitlabRepositoriesTidPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiGitlabRepositoriesTidPutResponse, ApiGitlabRepositoriesTidPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/gitlab_repositories/{tid}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a GlobalSearch resource.
 * Creates a GlobalSearch resource.
 */
export const apiGlobalSearchesPost = <ThrowOnError extends boolean = false>(options: Options<ApiGlobalSearchesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiGlobalSearchesPostResponse, ApiGlobalSearchesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/global_searches',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Improvement resources.
 * Retrieves the collection of Improvement resources.
 */
export const apiImprovementsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiImprovementsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiImprovementsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/improvements',
    ...options
  })
}

/**
 * Creates a Improvement resource.
 * Creates a Improvement resource.
 */
export const apiImprovementsPost = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiImprovementsPostResponse, ApiImprovementsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvements',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Improvement resource.
 * Removes the Improvement resource.
 */
export const apiImprovementsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiImprovementsIdDeleteResponse, ApiImprovementsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvements/{id}',
    ...options
  })
}

/**
 * Retrieves a Improvement resource.
 * Retrieves a Improvement resource.
 */
export const apiImprovementsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiImprovementsIdGetResponse, ApiImprovementsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvements/{id}',
    ...options
  })
}

/**
 * Replaces the Improvement resource.
 * Replaces the Improvement resource.
 */
export const apiImprovementsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiImprovementsIdPutResponse, ApiImprovementsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvements/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a Improvement resource.
 * Creates a Improvement resource.
 */
export const apiImprovementsIdvoteDownPost = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementsIdvoteDownPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiImprovementsIdvoteDownPostResponse, ApiImprovementsIdvoteDownPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvements/{id}/vote_down',
    ...options
  })
}

/**
 * Creates a Improvement resource.
 * Creates a Improvement resource.
 */
export const apiImprovementsIdvoteUpPost = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementsIdvoteUpPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiImprovementsIdvoteUpPostResponse, ApiImprovementsIdvoteUpPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvements/{id}/vote_up',
    ...options
  })
}

/**
 * Retrieves the collection of ImprovementScope resources.
 * Retrieves the collection of ImprovementScope resources.
 */
export const apiImprovementScopesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiImprovementScopesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiImprovementScopesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/improvement_scopes',
    ...options
  })
}

/**
 * Creates a ImprovementScope resource.
 * Creates a ImprovementScope resource.
 */
export const apiImprovementScopesPost = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementScopesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiImprovementScopesPostResponse, ApiImprovementScopesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_scopes',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the ImprovementScope resource.
 * Removes the ImprovementScope resource.
 */
export const apiImprovementScopesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementScopesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiImprovementScopesIdDeleteResponse, ApiImprovementScopesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_scopes/{id}',
    ...options
  })
}

/**
 * Retrieves a ImprovementScope resource.
 * Retrieves a ImprovementScope resource.
 */
export const apiImprovementScopesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementScopesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiImprovementScopesIdGetResponse, ApiImprovementScopesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_scopes/{id}',
    ...options
  })
}

/**
 * Replaces the ImprovementScope resource.
 * Replaces the ImprovementScope resource.
 */
export const apiImprovementScopesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementScopesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiImprovementScopesIdPutResponse, ApiImprovementScopesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_scopes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of ImprovementThread resources.
 * Retrieves the collection of ImprovementThread resources.
 */
export const apiImprovementThreadsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiImprovementThreadsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiImprovementThreadsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/improvement_threads',
    ...options
  })
}

/**
 * Creates a ImprovementThread resource.
 * Creates a ImprovementThread resource.
 */
export const apiImprovementThreadsPost = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementThreadsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiImprovementThreadsPostResponse, ApiImprovementThreadsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_threads',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the ImprovementThread resource.
 * Removes the ImprovementThread resource.
 */
export const apiImprovementThreadsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementThreadsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiImprovementThreadsIdDeleteResponse, ApiImprovementThreadsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_threads/{id}',
    ...options
  })
}

/**
 * Retrieves a ImprovementThread resource.
 * Retrieves a ImprovementThread resource.
 */
export const apiImprovementThreadsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementThreadsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiImprovementThreadsIdGetResponse, ApiImprovementThreadsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_threads/{id}',
    ...options
  })
}

/**
 * Replaces the ImprovementThread resource.
 * Replaces the ImprovementThread resource.
 */
export const apiImprovementThreadsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementThreadsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiImprovementThreadsIdPutResponse, ApiImprovementThreadsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_threads/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of ImprovementTopic resources.
 * Retrieves the collection of ImprovementTopic resources.
 */
export const apiImprovementTopicsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiImprovementTopicsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiImprovementTopicsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/improvement_topics',
    ...options
  })
}

/**
 * Creates a ImprovementTopic resource.
 * Creates a ImprovementTopic resource.
 */
export const apiImprovementTopicsPost = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementTopicsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiImprovementTopicsPostResponse, ApiImprovementTopicsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_topics',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the ImprovementTopic resource.
 * Removes the ImprovementTopic resource.
 */
export const apiImprovementTopicsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementTopicsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiImprovementTopicsIdDeleteResponse, ApiImprovementTopicsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_topics/{id}',
    ...options
  })
}

/**
 * Retrieves a ImprovementTopic resource.
 * Retrieves a ImprovementTopic resource.
 */
export const apiImprovementTopicsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementTopicsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiImprovementTopicsIdGetResponse, ApiImprovementTopicsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_topics/{id}',
    ...options
  })
}

/**
 * Replaces the ImprovementTopic resource.
 * Replaces the ImprovementTopic resource.
 */
export const apiImprovementTopicsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiImprovementTopicsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiImprovementTopicsIdPutResponse, ApiImprovementTopicsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/improvement_topics/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of InfoboardEntry resources.
 * Retrieves the collection of InfoboardEntry resources.
 */
export const apiInfoboardEntriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiInfoboardEntriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiInfoboardEntriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/infoboard_entries',
    ...options
  })
}

/**
 * Creates a InfoboardEntry resource.
 * Creates a InfoboardEntry resource.
 */
export const apiInfoboardEntriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardEntriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiInfoboardEntriesPostResponse, ApiInfoboardEntriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entries',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the InfoboardEntry resource.
 * Removes the InfoboardEntry resource.
 */
export const apiInfoboardEntriesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardEntriesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiInfoboardEntriesIdDeleteResponse, ApiInfoboardEntriesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entries/{id}',
    ...options
  })
}

/**
 * Retrieves a InfoboardEntry resource.
 * Retrieves a InfoboardEntry resource.
 */
export const apiInfoboardEntriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardEntriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiInfoboardEntriesIdGetResponse, ApiInfoboardEntriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entries/{id}',
    ...options
  })
}

/**
 * Replaces the InfoboardEntry resource.
 * Replaces the InfoboardEntry resource.
 */
export const apiInfoboardEntriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardEntriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiInfoboardEntriesIdPutResponse, ApiInfoboardEntriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of InfoboardEntryUserMeta resources.
 * Retrieves the collection of InfoboardEntryUserMeta resources.
 */
export const apiInfoboardEntryUserMetasGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiInfoboardEntryUserMetasGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiInfoboardEntryUserMetasGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entry_user_metas',
    ...options
  })
}

/**
 * Creates a InfoboardEntryUserMeta resource.
 * Creates a InfoboardEntryUserMeta resource.
 */
export const apiInfoboardEntryUserMetasPost = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardEntryUserMetasPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiInfoboardEntryUserMetasPostResponse, ApiInfoboardEntryUserMetasPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entry_user_metas',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the InfoboardEntryUserMeta resource.
 * Removes the InfoboardEntryUserMeta resource.
 */
export const apiInfoboardEntryUserMetasIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardEntryUserMetasIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiInfoboardEntryUserMetasIdDeleteResponse, ApiInfoboardEntryUserMetasIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entry_user_metas/{id}',
    ...options
  })
}

/**
 * Retrieves a InfoboardEntryUserMeta resource.
 * Retrieves a InfoboardEntryUserMeta resource.
 */
export const apiInfoboardEntryUserMetasIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardEntryUserMetasIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiInfoboardEntryUserMetasIdGetResponse, ApiInfoboardEntryUserMetasIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entry_user_metas/{id}',
    ...options
  })
}

/**
 * Replaces the InfoboardEntryUserMeta resource.
 * Replaces the InfoboardEntryUserMeta resource.
 */
export const apiInfoboardEntryUserMetasIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardEntryUserMetasIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiInfoboardEntryUserMetasIdPutResponse, ApiInfoboardEntryUserMetasIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_entry_user_metas/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of InfoboardResponse resources.
 * Retrieves the collection of InfoboardResponse resources.
 */
export const apiInfoboardResponsesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiInfoboardResponsesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiInfoboardResponsesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/infoboard_responses',
    ...options
  })
}

/**
 * Creates a InfoboardResponse resource.
 * Creates a InfoboardResponse resource.
 */
export const apiInfoboardResponsesPost = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardResponsesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiInfoboardResponsesPostResponse, ApiInfoboardResponsesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_responses',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the InfoboardResponse resource.
 * Removes the InfoboardResponse resource.
 */
export const apiInfoboardResponsesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardResponsesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiInfoboardResponsesIdDeleteResponse, ApiInfoboardResponsesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_responses/{id}',
    ...options
  })
}

/**
 * Retrieves a InfoboardResponse resource.
 * Retrieves a InfoboardResponse resource.
 */
export const apiInfoboardResponsesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardResponsesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiInfoboardResponsesIdGetResponse, ApiInfoboardResponsesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_responses/{id}',
    ...options
  })
}

/**
 * Replaces the InfoboardResponse resource.
 * Replaces the InfoboardResponse resource.
 */
export const apiInfoboardResponsesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiInfoboardResponsesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiInfoboardResponsesIdPutResponse, ApiInfoboardResponsesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/infoboard_responses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of JourFixeEntry resources.
 * Retrieves the collection of JourFixeEntry resources.
 */
export const apiJourFixeEntriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiJourFixeEntriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiJourFixeEntriesGetCollectionResponse, ApiJourFixeEntriesGetCollectionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/jour_fixe_entries',
    ...options
  })
}

/**
 * Creates a JourFixeEntry resource.
 * Creates a JourFixeEntry resource.
 */
export const apiJourFixeEntriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiJourFixeEntriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiJourFixeEntriesPostResponse, ApiJourFixeEntriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/jour_fixe_entries',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a JourFixeEntry resource.
 * Retrieves a JourFixeEntry resource.
 */
export const apiJourFixeEntriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiJourFixeEntriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiJourFixeEntriesIdGetResponse, ApiJourFixeEntriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/jour_fixe_entries/{id}',
    ...options
  })
}

/**
 * Updates the JourFixeEntry resource.
 * Updates the JourFixeEntry resource.
 */
export const apiJourFixeEntriesIdPatch = <ThrowOnError extends boolean = false>(options: Options<ApiJourFixeEntriesIdPatchData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).patch<ApiJourFixeEntriesIdPatchResponse, ApiJourFixeEntriesIdPatchError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/jour_fixe_entries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/merge-patch+json',
      ...options?.headers
    }
  })
}

/**
 * Replaces the JourFixeEntry resource.
 * Replaces the JourFixeEntry resource.
 */
export const apiJourFixeEntriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiJourFixeEntriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiJourFixeEntriesIdPutResponse, ApiJourFixeEntriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/jour_fixe_entries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a KioskAccess resource.
 * Retrieves a KioskAccess resource.
 */
export const apiKioskAccessesDeviceIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiKioskAccessesDeviceIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiKioskAccessesDeviceIdGetResponse, ApiKioskAccessesDeviceIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/kiosk_accesses/{deviceId}',
    ...options
  })
}

/**
 * Replaces the KioskAccess resource.
 * Replaces the KioskAccess resource.
 */
export const apiKioskAccessesDeviceIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiKioskAccessesDeviceIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiKioskAccessesDeviceIdPutResponse, ApiKioskAccessesDeviceIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/kiosk_accesses/{deviceId}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a KioskAuth resource.
 * Creates a KioskAuth resource.
 */
export const kioskAuth = <ThrowOnError extends boolean = false>(options: Options<KioskAuthData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<KioskAuthResponse, KioskAuthError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/kiosk_auths',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a KioskData resource.
 * Retrieves a KioskData resource.
 */
export const apiKioskdataGet = <ThrowOnError extends boolean = false>(options?: Options<ApiKioskdataGetData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiKioskdataGetResponse, ApiKioskdataGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/kiosk/data',
    ...options
  })
}

/**
 * Logout the user
 * Logout the user
 */
export const loginLogout = <ThrowOnError extends boolean = false>(options?: Options<LoginLogoutData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/logout',
    ...options
  })
}

/**
 * Renews a token by refresh_token.
 * Renews a token by refresh_token.
 */
export const loginRefreshToken = <ThrowOnError extends boolean = false>(options?: Options<LoginRefreshTokenData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<LoginRefreshTokenResponse, LoginRefreshTokenError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/token/refresh',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Creates a user token.
 * Creates a user token.
 */
export const loginCheckPost = <ThrowOnError extends boolean = false>(options: Options<LoginCheckPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<LoginCheckPostResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/login_check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of MailRecipient resources.
 * Retrieves the collection of MailRecipient resources.
 */
export const apiMailRecipientsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiMailRecipientsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiMailRecipientsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/mail_recipients',
    ...options
  })
}

/**
 * Creates a MailRecipient resource.
 * Creates a MailRecipient resource.
 */
export const apiMailRecipientsPost = <ThrowOnError extends boolean = false>(options: Options<ApiMailRecipientsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiMailRecipientsPostResponse, ApiMailRecipientsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/mail_recipients',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the MailRecipient resource.
 * Removes the MailRecipient resource.
 */
export const apiMailRecipientsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiMailRecipientsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiMailRecipientsIdDeleteResponse, ApiMailRecipientsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/mail_recipients/{id}',
    ...options
  })
}

/**
 * Retrieves a MailRecipient resource.
 * Retrieves a MailRecipient resource.
 */
export const apiMailRecipientsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiMailRecipientsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiMailRecipientsIdGetResponse, ApiMailRecipientsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/mail_recipients/{id}',
    ...options
  })
}

/**
 * Replaces the MailRecipient resource.
 * Replaces the MailRecipient resource.
 */
export const apiMailRecipientsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiMailRecipientsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiMailRecipientsIdPutResponse, ApiMailRecipientsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/mail_recipients/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the url and token for mercure subscription.
 * Retrieves the url and token for mercure subscription.
 */
export const mercureSubscribe = <ThrowOnError extends boolean = false>(options?: Options<MercureSubscribeData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<MercureSubscribeResponse, MercureSubscribeError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/mercure-subscribe',
    ...options
  })
}

/**
 * Retrieves the collection of Module resources.
 * Retrieves the collection of Module resources.
 */
export const apiModulesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiModulesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiModulesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/modules',
    ...options
  })
}

/**
 * Creates a Module resource.
 * Creates a Module resource.
 */
export const apiModulesPost = <ThrowOnError extends boolean = false>(options: Options<ApiModulesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiModulesPostResponse, ApiModulesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/modules',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Module resource.
 * Removes the Module resource.
 */
export const apiModulesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiModulesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiModulesIdDeleteResponse, ApiModulesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/modules/{id}',
    ...options
  })
}

/**
 * Retrieves a Module resource.
 * Retrieves a Module resource.
 */
export const apiModulesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiModulesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiModulesIdGetResponse, ApiModulesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/modules/{id}',
    ...options
  })
}

/**
 * Replaces the Module resource.
 * Replaces the Module resource.
 */
export const apiModulesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiModulesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiModulesIdPutResponse, ApiModulesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/modules/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of ModuleChangeLog resources.
 * Retrieves the collection of ModuleChangeLog resources.
 */
export const apiModuleChangeLogsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiModuleChangeLogsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiModuleChangeLogsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_change_logs',
    ...options
  })
}

/**
 * Creates a ModuleChangeLog resource.
 * Creates a ModuleChangeLog resource.
 */
export const apiModuleChangeLogsPost = <ThrowOnError extends boolean = false>(options: Options<ApiModuleChangeLogsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiModuleChangeLogsPostResponse, ApiModuleChangeLogsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_change_logs',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the ModuleChangeLog resource.
 * Removes the ModuleChangeLog resource.
 */
export const apiModuleChangeLogsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiModuleChangeLogsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiModuleChangeLogsIdDeleteResponse, ApiModuleChangeLogsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_change_logs/{id}',
    ...options
  })
}

/**
 * Retrieves a ModuleChangeLog resource.
 * Retrieves a ModuleChangeLog resource.
 */
export const apiModuleChangeLogsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiModuleChangeLogsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiModuleChangeLogsIdGetResponse, ApiModuleChangeLogsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_change_logs/{id}',
    ...options
  })
}

/**
 * Replaces the ModuleChangeLog resource.
 * Replaces the ModuleChangeLog resource.
 */
export const apiModuleChangeLogsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiModuleChangeLogsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiModuleChangeLogsIdPutResponse, ApiModuleChangeLogsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_change_logs/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of ModuleGroup resources.
 * Retrieves the collection of ModuleGroup resources.
 */
export const apiModuleGroupsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiModuleGroupsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiModuleGroupsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/module_groups',
    ...options
  })
}

/**
 * Creates a ModuleGroup resource.
 * Creates a ModuleGroup resource.
 */
export const apiModuleGroupsPost = <ThrowOnError extends boolean = false>(options: Options<ApiModuleGroupsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiModuleGroupsPostResponse, ApiModuleGroupsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_groups',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the ModuleGroup resource.
 * Removes the ModuleGroup resource.
 */
export const apiModuleGroupsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiModuleGroupsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiModuleGroupsIdDeleteResponse, ApiModuleGroupsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_groups/{id}',
    ...options
  })
}

/**
 * Retrieves a ModuleGroup resource.
 * Retrieves a ModuleGroup resource.
 */
export const apiModuleGroupsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiModuleGroupsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiModuleGroupsIdGetResponse, ApiModuleGroupsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_groups/{id}',
    ...options
  })
}

/**
 * Replaces the ModuleGroup resource.
 * Replaces the ModuleGroup resource.
 */
export const apiModuleGroupsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiModuleGroupsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiModuleGroupsIdPutResponse, ApiModuleGroupsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_groups/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of ModuleHashtag resources.
 * Retrieves the collection of ModuleHashtag resources.
 */
export const apiModuleHashtagsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiModuleHashtagsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiModuleHashtagsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/module_hashtags',
    ...options
  })
}

/**
 * Creates a ModuleHashtag resource.
 * Creates a ModuleHashtag resource.
 */
export const apiModuleHashtagsPost = <ThrowOnError extends boolean = false>(options: Options<ApiModuleHashtagsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiModuleHashtagsPostResponse, ApiModuleHashtagsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_hashtags',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the ModuleHashtag resource.
 * Removes the ModuleHashtag resource.
 */
export const apiModuleHashtagsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiModuleHashtagsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiModuleHashtagsIdDeleteResponse, ApiModuleHashtagsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_hashtags/{id}',
    ...options
  })
}

/**
 * Retrieves a ModuleHashtag resource.
 * Retrieves a ModuleHashtag resource.
 */
export const apiModuleHashtagsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiModuleHashtagsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiModuleHashtagsIdGetResponse, ApiModuleHashtagsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_hashtags/{id}',
    ...options
  })
}

/**
 * Replaces the ModuleHashtag resource.
 * Replaces the ModuleHashtag resource.
 */
export const apiModuleHashtagsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiModuleHashtagsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiModuleHashtagsIdPutResponse, ApiModuleHashtagsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/module_hashtags/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Order resources.
 * Retrieves the collection of Order resources.
 */
export const apiOrdersGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiOrdersGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiOrdersGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/orders',
    ...options
  })
}

/**
 * Creates a Order resource.
 * Creates a Order resource.
 */
export const apiOrdersPost = <ThrowOnError extends boolean = false>(options: Options<ApiOrdersPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiOrdersPostResponse, ApiOrdersPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/orders',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Order resource.
 * Removes the Order resource.
 */
export const apiOrdersIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiOrdersIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiOrdersIdDeleteResponse, ApiOrdersIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/orders/{id}',
    ...options
  })
}

/**
 * Retrieves a Order resource.
 * Retrieves a Order resource.
 */
export const apiOrdersIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiOrdersIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiOrdersIdGetResponse, ApiOrdersIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/orders/{id}',
    ...options
  })
}

/**
 * Replaces the Order resource.
 * Replaces the Order resource.
 */
export const apiOrdersIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiOrdersIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiOrdersIdPutResponse, ApiOrdersIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/orders/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Order resources.
 * Retrieves the collection of Order resources.
 */
export const apiOrdersUnsyncedGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiOrdersUnsyncedGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiOrdersUnsyncedGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/orders_unsynced',
    ...options
  })
}

/**
 * Retrieves the collection of OrderState resources.
 * Retrieves the collection of OrderState resources.
 */
export const apiOrderStatesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiOrderStatesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiOrderStatesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/order_states',
    ...options
  })
}

/**
 * Creates a OrderState resource.
 * Creates a OrderState resource.
 */
export const apiOrderStatesPost = <ThrowOnError extends boolean = false>(options: Options<ApiOrderStatesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiOrderStatesPostResponse, ApiOrderStatesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/order_states',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the OrderState resource.
 * Removes the OrderState resource.
 */
export const apiOrderStatesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiOrderStatesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiOrderStatesIdDeleteResponse, ApiOrderStatesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/order_states/{id}',
    ...options
  })
}

/**
 * Retrieves a OrderState resource.
 * Retrieves a OrderState resource.
 */
export const apiOrderStatesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiOrderStatesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiOrderStatesIdGetResponse, ApiOrderStatesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/order_states/{id}',
    ...options
  })
}

/**
 * Replaces the OrderState resource.
 * Replaces the OrderState resource.
 */
export const apiOrderStatesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiOrderStatesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiOrderStatesIdPutResponse, ApiOrderStatesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/order_states/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Changes the current users password.
 * Changes the current users password.
 */
export const changePassword = <ThrowOnError extends boolean = false>(options?: Options<ChangePasswordData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<ChangePasswordResponse, ChangePasswordError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/other/change-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Changes the users password by verification code
 * Changes the users password by verification code
 */
export const passwordChangeConfirm = <ThrowOnError extends boolean = false>(options?: Options<PasswordChangeConfirmData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/other/change-password-confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Creates a new password reset request
 * Creates a new password reset request
 */
export const requestResetPassword = <ThrowOnError extends boolean = false>(options?: Options<RequestResetPasswordData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/other/request-reset-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Changes the users password by verification code
 * Changes the users password by verification code
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options?: Options<ResetPasswordData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/other/reset-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of PlannerCalendar resources.
 * Retrieves the collection of PlannerCalendar resources.
 */
export const apiPlannerCalendarsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiPlannerCalendarsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiPlannerCalendarsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/planner_calendars',
    ...options
  })
}

/**
 * Creates a PlannerCalendar resource.
 * Creates a PlannerCalendar resource.
 */
export const apiPlannerCalendarsPost = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerCalendarsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiPlannerCalendarsPostResponse, ApiPlannerCalendarsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_calendars',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the PlannerCalendar resource.
 * Removes the PlannerCalendar resource.
 */
export const apiPlannerCalendarsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerCalendarsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiPlannerCalendarsIdDeleteResponse, ApiPlannerCalendarsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_calendars/{id}',
    ...options
  })
}

/**
 * Retrieves a PlannerCalendar resource.
 * Retrieves a PlannerCalendar resource.
 */
export const apiPlannerCalendarsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerCalendarsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiPlannerCalendarsIdGetResponse, ApiPlannerCalendarsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_calendars/{id}',
    ...options
  })
}

/**
 * Replaces the PlannerCalendar resource.
 * Replaces the PlannerCalendar resource.
 */
export const apiPlannerCalendarsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerCalendarsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiPlannerCalendarsIdPutResponse, ApiPlannerCalendarsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_calendars/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of PlannerColor resources.
 * Retrieves the collection of PlannerColor resources.
 */
export const apiPlannerColorsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiPlannerColorsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiPlannerColorsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/planner_colors',
    ...options
  })
}

/**
 * Creates a PlannerColor resource.
 * Creates a PlannerColor resource.
 */
export const apiPlannerColorsPost = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerColorsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiPlannerColorsPostResponse, ApiPlannerColorsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_colors',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the PlannerColor resource.
 * Removes the PlannerColor resource.
 */
export const apiPlannerColorsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerColorsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiPlannerColorsIdDeleteResponse, ApiPlannerColorsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_colors/{id}',
    ...options
  })
}

/**
 * Retrieves a PlannerColor resource.
 * Retrieves a PlannerColor resource.
 */
export const apiPlannerColorsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerColorsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiPlannerColorsIdGetResponse, ApiPlannerColorsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_colors/{id}',
    ...options
  })
}

/**
 * Replaces the PlannerColor resource.
 * Replaces the PlannerColor resource.
 */
export const apiPlannerColorsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerColorsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiPlannerColorsIdPutResponse, ApiPlannerColorsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_colors/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of PlannerEntry resources.
 * Retrieves the collection of PlannerEntry resources.
 */
export const apiPlannerEntriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiPlannerEntriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiPlannerEntriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/planner_entries',
    ...options
  })
}

/**
 * Creates a PlannerEntry resource.
 * Creates a PlannerEntry resource.
 */
export const apiPlannerEntriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerEntriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiPlannerEntriesPostResponse, ApiPlannerEntriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_entries',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the PlannerEntry resource.
 * Removes the PlannerEntry resource.
 */
export const apiPlannerEntriesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerEntriesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiPlannerEntriesIdDeleteResponse, ApiPlannerEntriesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_entries/{id}',
    ...options
  })
}

/**
 * Retrieves a PlannerEntry resource.
 * Retrieves a PlannerEntry resource.
 */
export const apiPlannerEntriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerEntriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiPlannerEntriesIdGetResponse, ApiPlannerEntriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_entries/{id}',
    ...options
  })
}

/**
 * Replaces the PlannerEntry resource.
 * Replaces the PlannerEntry resource.
 */
export const apiPlannerEntriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerEntriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiPlannerEntriesIdPutResponse, ApiPlannerEntriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_entries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of PlannerEntry resources.
 * Retrieves the collection of PlannerEntry resources.
 */
export const apiPlannerEntriesRangedDateStartDateEndGetCollection = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerEntriesRangedDateStartDateEndGetCollectionData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiPlannerEntriesRangedDateStartDateEndGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/planner_entries_ranged/{dateStart}/{dateEnd}',
    ...options
  })
}

/**
 * Retrieves the collection of PlannerPermission resources.
 * Retrieves the collection of PlannerPermission resources.
 */
export const apiPlannerPermissionsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiPlannerPermissionsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiPlannerPermissionsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/planner_permissions',
    ...options
  })
}

/**
 * Creates a PlannerPermission resource.
 * Creates a PlannerPermission resource.
 */
export const apiPlannerPermissionsPost = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerPermissionsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiPlannerPermissionsPostResponse, ApiPlannerPermissionsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_permissions',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the PlannerPermission resource.
 * Removes the PlannerPermission resource.
 */
export const apiPlannerPermissionsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerPermissionsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiPlannerPermissionsIdDeleteResponse, ApiPlannerPermissionsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_permissions/{id}',
    ...options
  })
}

/**
 * Retrieves a PlannerPermission resource.
 * Retrieves a PlannerPermission resource.
 */
export const apiPlannerPermissionsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerPermissionsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiPlannerPermissionsIdGetResponse, ApiPlannerPermissionsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_permissions/{id}',
    ...options
  })
}

/**
 * Replaces the PlannerPermission resource.
 * Replaces the PlannerPermission resource.
 */
export const apiPlannerPermissionsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiPlannerPermissionsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiPlannerPermissionsIdPutResponse, ApiPlannerPermissionsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/planner_permissions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Role resources.
 * Retrieves the collection of Role resources.
 */
export const apiRolesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiRolesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiRolesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/roles',
    ...options
  })
}

/**
 * Creates a Role resource.
 * Creates a Role resource.
 */
export const apiRolesPost = <ThrowOnError extends boolean = false>(options: Options<ApiRolesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiRolesPostResponse, ApiRolesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/roles',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a Role resource.
 * Retrieves a Role resource.
 */
export const apiRolesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiRolesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiRolesIdGetResponse, ApiRolesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/roles/{id}',
    ...options
  })
}

/**
 * Replaces the Role resource.
 * Replaces the Role resource.
 */
export const apiRolesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiRolesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiRolesIdPutResponse, ApiRolesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/roles/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of SentMail resources.
 * Retrieves the collection of SentMail resources.
 */
export const apiSentMailsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiSentMailsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiSentMailsGetCollectionResponse, ApiSentMailsGetCollectionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/sent_mails',
    ...options
  })
}

/**
 * Creates a SentMail resource.
 * Creates a SentMail resource.
 */
export const apiSentMailsPost = <ThrowOnError extends boolean = false>(options: Options<ApiSentMailsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiSentMailsPostResponse, ApiSentMailsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/sent_mails',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a SentMail resource.
 * Retrieves a SentMail resource.
 */
export const apiSentMailsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiSentMailsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiSentMailsIdGetResponse, ApiSentMailsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/sent_mails/{id}',
    ...options
  })
}

/**
 * Replaces the SentMail resource.
 * Replaces the SentMail resource.
 */
export const apiSentMailsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiSentMailsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiSentMailsIdPutResponse, ApiSentMailsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/sent_mails/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of ServiceRevenue resources.
 * Retrieves the collection of ServiceRevenue resources.
 */
export const apiServiceRevenuesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiServiceRevenuesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiServiceRevenuesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/service_revenues',
    ...options
  })
}

/**
 * Creates a ServiceRevenue resource.
 * Creates a ServiceRevenue resource.
 */
export const apiServiceRevenuesPost = <ThrowOnError extends boolean = false>(options: Options<ApiServiceRevenuesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiServiceRevenuesPostResponse, ApiServiceRevenuesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/service_revenues',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the ServiceRevenue resource.
 * Removes the ServiceRevenue resource.
 */
export const apiServiceRevenuesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiServiceRevenuesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiServiceRevenuesIdDeleteResponse, ApiServiceRevenuesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/service_revenues/{id}',
    ...options
  })
}

/**
 * Retrieves a ServiceRevenue resource.
 * Retrieves a ServiceRevenue resource.
 */
export const apiServiceRevenuesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiServiceRevenuesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiServiceRevenuesIdGetResponse, ApiServiceRevenuesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/service_revenues/{id}',
    ...options
  })
}

/**
 * Replaces the ServiceRevenue resource.
 * Replaces the ServiceRevenue resource.
 */
export const apiServiceRevenuesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiServiceRevenuesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiServiceRevenuesIdPutResponse, ApiServiceRevenuesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/service_revenues/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of ServiceType resources.
 * Retrieves the collection of ServiceType resources.
 */
export const apiServiceTypesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiServiceTypesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiServiceTypesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/service_types',
    ...options
  })
}

/**
 * Creates a ServiceType resource.
 * Creates a ServiceType resource.
 */
export const apiServiceTypesPost = <ThrowOnError extends boolean = false>(options: Options<ApiServiceTypesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiServiceTypesPostResponse, ApiServiceTypesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/service_types',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a ServiceType resource.
 * Retrieves a ServiceType resource.
 */
export const apiServiceTypesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiServiceTypesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiServiceTypesIdGetResponse, ApiServiceTypesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/service_types/{id}',
    ...options
  })
}

/**
 * Replaces the ServiceType resource.
 * Replaces the ServiceType resource.
 */
export const apiServiceTypesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiServiceTypesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiServiceTypesIdPutResponse, ApiServiceTypesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/service_types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of SyncObject resources.
 * Retrieves the collection of SyncObject resources.
 */
export const apiSyncObjectsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiSyncObjectsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiSyncObjectsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/sync_objects',
    ...options
  })
}

/**
 * Creates a SyncObject resource.
 * Creates a SyncObject resource.
 */
export const apiSyncObjectsPost = <ThrowOnError extends boolean = false>(options: Options<ApiSyncObjectsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiSyncObjectsPostResponse, ApiSyncObjectsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/sync_objects',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a SyncObject resource.
 * Retrieves a SyncObject resource.
 */
export const apiSyncObjectsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiSyncObjectsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiSyncObjectsIdGetResponse, ApiSyncObjectsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/sync_objects/{id}',
    ...options
  })
}

/**
 * Replaces the SyncObject resource.
 * Replaces the SyncObject resource.
 */
export const apiSyncObjectsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiSyncObjectsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiSyncObjectsIdPutResponse, ApiSyncObjectsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/sync_objects/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Ping endpoint to track client activity
 * Returns 204 No Content if reachable. Used by frontend to report activity or availability.
 */
export const ping = <ThrowOnError extends boolean = false>(options?: Options<PingData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<PingResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/ping',
    ...options
  })
}

/**
 * Server-Informationen
 */
export const getServerInfo = <ThrowOnError extends boolean = false>(options?: Options<GetServerInfoData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetServerInfoResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/server-info',
    ...options
  })
}

/**
 * Retrieves the collection of Task resources.
 * Retrieves the collection of Task resources.
 */
export const apiTasksGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiTasksGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiTasksGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/tasks',
    ...options
  })
}

/**
 * Creates a Task resource.
 * Creates a Task resource.
 */
export const apiTasksPost = <ThrowOnError extends boolean = false>(options: Options<ApiTasksPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTasksPostResponse, ApiTasksPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/tasks',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the Task resource.
 * Removes the Task resource.
 */
export const apiTasksIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTasksIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTasksIdDeleteResponse, ApiTasksIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/tasks/{id}',
    ...options
  })
}

/**
 * Retrieves a Task resource.
 * Retrieves a Task resource.
 */
export const apiTasksIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiTasksIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiTasksIdGetResponse, ApiTasksIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/tasks/{id}',
    ...options
  })
}

/**
 * Replaces the Task resource.
 * Replaces the Task resource.
 */
export const apiTasksIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiTasksIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiTasksIdPutResponse, ApiTasksIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a TaskComment resource.
 * Creates a TaskComment resource.
 */
export const apiTaskCommentsPost = <ThrowOnError extends boolean = false>(options: Options<ApiTaskCommentsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTaskCommentsPostResponse, ApiTaskCommentsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_comments',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the TaskComment resource.
 * Removes the TaskComment resource.
 */
export const apiTaskCommentsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTaskCommentsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTaskCommentsIdDeleteResponse, ApiTaskCommentsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_comments/{id}',
    ...options
  })
}

/**
 * Retrieves the collection of TaskEstimation resources.
 * Retrieves the collection of TaskEstimation resources.
 */
export const apiTaskEstimationsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiTaskEstimationsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiTaskEstimationsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/task_estimations',
    ...options
  })
}

/**
 * Creates a TaskEstimation resource.
 * Creates a TaskEstimation resource.
 */
export const apiTaskEstimationsPost = <ThrowOnError extends boolean = false>(options: Options<ApiTaskEstimationsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTaskEstimationsPostResponse, ApiTaskEstimationsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_estimations',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the TaskEstimation resource.
 * Removes the TaskEstimation resource.
 */
export const apiTaskEstimationsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTaskEstimationsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTaskEstimationsIdDeleteResponse, ApiTaskEstimationsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_estimations/{id}',
    ...options
  })
}

/**
 * Retrieves a TaskEstimation resource.
 * Retrieves a TaskEstimation resource.
 */
export const apiTaskEstimationsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiTaskEstimationsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiTaskEstimationsIdGetResponse, ApiTaskEstimationsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_estimations/{id}',
    ...options
  })
}

/**
 * Replaces the TaskEstimation resource.
 * Replaces the TaskEstimation resource.
 */
export const apiTaskEstimationsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiTaskEstimationsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiTaskEstimationsIdPutResponse, ApiTaskEstimationsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_estimations/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a TaskLink resource.
 * Creates a TaskLink resource.
 */
export const apiTaskLinksPost = <ThrowOnError extends boolean = false>(options: Options<ApiTaskLinksPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTaskLinksPostResponse, ApiTaskLinksPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_links',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the TaskLink resource.
 * Removes the TaskLink resource.
 */
export const apiTaskLinksIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTaskLinksIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTaskLinksIdDeleteResponse, ApiTaskLinksIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_links/{id}',
    ...options
  })
}

/**
 * Retrieves the collection of TaskUserStory resources.
 * Retrieves the collection of TaskUserStory resources.
 */
export const apiTaskUserStoriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiTaskUserStoriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiTaskUserStoriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/task_user_stories',
    ...options
  })
}

/**
 * Creates a TaskUserStory resource.
 * Creates a TaskUserStory resource.
 */
export const apiTaskUserStoriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiTaskUserStoriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTaskUserStoriesPostResponse, ApiTaskUserStoriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_user_stories',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the TaskUserStory resource.
 * Removes the TaskUserStory resource.
 */
export const apiTaskUserStoriesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTaskUserStoriesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTaskUserStoriesIdDeleteResponse, ApiTaskUserStoriesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_user_stories/{id}',
    ...options
  })
}

/**
 * Retrieves a TaskUserStory resource.
 * Retrieves a TaskUserStory resource.
 */
export const apiTaskUserStoriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiTaskUserStoriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiTaskUserStoriesIdGetResponse, ApiTaskUserStoriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_user_stories/{id}',
    ...options
  })
}

/**
 * Replaces the TaskUserStory resource.
 * Replaces the TaskUserStory resource.
 */
export const apiTaskUserStoriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiTaskUserStoriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiTaskUserStoriesIdPutResponse, ApiTaskUserStoriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/task_user_stories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of TimePlanningEntry resources.
 * Retrieves the collection of TimePlanningEntry resources.
 */
export const apiTimePlanningEntriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiTimePlanningEntriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiTimePlanningEntriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/time_planning_entries',
    ...options
  })
}

/**
 * Creates a TimePlanningEntry resource.
 * Creates a TimePlanningEntry resource.
 */
export const apiTimePlanningEntriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiTimePlanningEntriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTimePlanningEntriesPostResponse, ApiTimePlanningEntriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_planning_entries',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the TimePlanningEntry resource.
 * Removes the TimePlanningEntry resource.
 */
export const apiTimePlanningEntriesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTimePlanningEntriesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTimePlanningEntriesIdDeleteResponse, ApiTimePlanningEntriesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_planning_entries/{id}',
    ...options
  })
}

/**
 * Retrieves a TimePlanningEntry resource.
 * Retrieves a TimePlanningEntry resource.
 */
export const apiTimePlanningEntriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiTimePlanningEntriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiTimePlanningEntriesIdGetResponse, ApiTimePlanningEntriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_planning_entries/{id}',
    ...options
  })
}

/**
 * Replaces the TimePlanningEntry resource.
 * Replaces the TimePlanningEntry resource.
 */
export const apiTimePlanningEntriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiTimePlanningEntriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiTimePlanningEntriesIdPutResponse, ApiTimePlanningEntriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_planning_entries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of TimeTracking resources.
 * Retrieves the collection of TimeTracking resources.
 */
export const apiTimeTrackingsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiTimeTrackingsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiTimeTrackingsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/time_trackings',
    ...options
  })
}

/**
 * Creates a TimeTracking resource.
 * Creates a TimeTracking resource.
 */
export const apiTimeTrackingsPost = <ThrowOnError extends boolean = false>(options: Options<ApiTimeTrackingsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTimeTrackingsPostResponse, ApiTimeTrackingsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_trackings',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the TimeTracking resource.
 * Removes the TimeTracking resource.
 */
export const apiTimeTrackingsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTimeTrackingsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTimeTrackingsIdDeleteResponse, ApiTimeTrackingsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_trackings/{id}',
    ...options
  })
}

/**
 * Retrieves a TimeTracking resource.
 * Retrieves a TimeTracking resource.
 */
export const apiTimeTrackingsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiTimeTrackingsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiTimeTrackingsIdGetResponse, ApiTimeTrackingsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_trackings/{id}',
    ...options
  })
}

/**
 * Replaces the TimeTracking resource.
 * Replaces the TimeTracking resource.
 */
export const apiTimeTrackingsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiTimeTrackingsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiTimeTrackingsIdPutResponse, ApiTimeTrackingsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_trackings/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of TimeTrackingStamp resources.
 * Retrieves the collection of TimeTrackingStamp resources.
 */
export const apiTimeTrackingStampsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiTimeTrackingStampsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiTimeTrackingStampsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/time_tracking_stamps',
    ...options
  })
}

/**
 * Creates a TimeTrackingStamp resource.
 * Creates a TimeTrackingStamp resource.
 */
export const apiTimeTrackingStampsPost = <ThrowOnError extends boolean = false>(options: Options<ApiTimeTrackingStampsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTimeTrackingStampsPostResponse, ApiTimeTrackingStampsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_tracking_stamps',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the TimeTrackingStamp resource.
 * Removes the TimeTrackingStamp resource.
 */
export const apiTimeTrackingStampsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTimeTrackingStampsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTimeTrackingStampsIdDeleteResponse, ApiTimeTrackingStampsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_tracking_stamps/{id}',
    ...options
  })
}

/**
 * Retrieves a TimeTrackingStamp resource.
 * Retrieves a TimeTrackingStamp resource.
 */
export const apiTimeTrackingStampsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiTimeTrackingStampsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiTimeTrackingStampsIdGetResponse, ApiTimeTrackingStampsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_tracking_stamps/{id}',
    ...options
  })
}

/**
 * Replaces the TimeTrackingStamp resource.
 * Replaces the TimeTrackingStamp resource.
 */
export const apiTimeTrackingStampsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiTimeTrackingStampsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiTimeTrackingStampsIdPutResponse, ApiTimeTrackingStampsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/time_tracking_stamps/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of TodoEntry resources.
 * Retrieves the collection of TodoEntry resources.
 */
export const apiTodoEntriesGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiTodoEntriesGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiTodoEntriesGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/todo_entries',
    ...options
  })
}

/**
 * Creates a TodoEntry resource.
 * Creates a TodoEntry resource.
 */
export const apiTodoEntriesPost = <ThrowOnError extends boolean = false>(options: Options<ApiTodoEntriesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiTodoEntriesPostResponse, ApiTodoEntriesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/todo_entries',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the TodoEntry resource.
 * Removes the TodoEntry resource.
 */
export const apiTodoEntriesIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTodoEntriesIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiTodoEntriesIdDeleteResponse, ApiTodoEntriesIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/todo_entries/{id}',
    ...options
  })
}

/**
 * Retrieves a TodoEntry resource.
 * Retrieves a TodoEntry resource.
 */
export const apiTodoEntriesIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiTodoEntriesIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiTodoEntriesIdGetResponse, ApiTodoEntriesIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/todo_entries/{id}',
    ...options
  })
}

/**
 * Replaces the TodoEntry resource.
 * Replaces the TodoEntry resource.
 */
export const apiTodoEntriesIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiTodoEntriesIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiTodoEntriesIdPutResponse, ApiTodoEntriesIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/todo_entries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Starts the 2FA disable process
 * Verifies user's password and starts 2FA disable session if correct.
 */
export const tfaDisable = <ThrowOnError extends boolean = false>(options: Options<TfaDisableData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<TfaDisableResponse, TfaDisableError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/tfa/disable',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Verifies OTP to complete 2FA disable process
 * Checks provided OTP or backup code, then disables 2FA for the account.
 */
export const tfaDisableVerify = <ThrowOnError extends boolean = false>(options: Options<TfaDisableVerifyData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<TfaDisableVerifyResponse, TfaDisableVerifyError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/tfa/disable/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Starts the account's 2FA setup
 * Generates secret and QR code for 2FA activation
 */
export const tfaSetup = <ThrowOnError extends boolean = false>(options?: Options<TfaSetupData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<TfaSetupResponse, TfaSetupError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/tfa/setup',
    ...options
  })
}

/**
 * Verifies the 2FA setup with provided TOTP code
 * Checks the provided TOTP code. If valid, enables 2FA and returns backup codes.
 */
export const tfaSetupVerify = <ThrowOnError extends boolean = false>(options?: Options<TfaSetupVerifyData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<TfaSetupVerifyResponse, TfaSetupVerifyError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/tfa/setup/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of Upload resources.
 * Retrieves the collection of Upload resources.
 */
export const apiUploadsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiUploadsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiUploadsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/uploads',
    ...options
  })
}

/**
 * Datei-Upload
 * Creates a Upload resource.
 */
export const apiUploadsPost = <ThrowOnError extends boolean = false>(options?: Options<ApiUploadsPostData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<ApiUploadsPostResponse, ApiUploadsPostError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/uploads',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers
    }
  })
}

/**
 * Removes the Upload resource.
 * Removes the Upload resource.
 */
export const apiUploadsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiUploadsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiUploadsIdDeleteResponse, ApiUploadsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/uploads/{id}',
    ...options
  })
}

/**
 * Retrieves a Upload resource.
 * Retrieves a Upload resource.
 */
export const apiUploadsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiUploadsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiUploadsIdGetResponse, ApiUploadsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/uploads/{id}',
    ...options
  })
}

/**
 * Replaces the Upload resource.
 * Replaces the Upload resource.
 */
export const apiUploadsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiUploadsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiUploadsIdPutResponse, ApiUploadsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/uploads/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of UserUploads resources.
 * Retrieves the collection of UserUploads resources.
 */
export const apiUserUploadsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiUserUploadsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiUserUploadsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/user_uploads',
    ...options
  })
}

/**
 * Creates a UserUploads resource.
 * Creates a UserUploads resource.
 */
export const apiUserUploadsPost = <ThrowOnError extends boolean = false>(options: Options<ApiUserUploadsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiUserUploadsPostResponse, ApiUserUploadsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/user_uploads',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the UserUploads resource.
 * Removes the UserUploads resource.
 */
export const apiUserUploadsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiUserUploadsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiUserUploadsIdDeleteResponse, ApiUserUploadsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/user_uploads/{id}',
    ...options
  })
}

/**
 * Retrieves a UserUploads resource.
 * Retrieves a UserUploads resource.
 */
export const apiUserUploadsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiUserUploadsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiUserUploadsIdGetResponse, ApiUserUploadsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/user_uploads/{id}',
    ...options
  })
}

/**
 * Replaces the UserUploads resource.
 * Replaces the UserUploads resource.
 */
export const apiUserUploadsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiUserUploadsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiUserUploadsIdPutResponse, ApiUserUploadsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/user_uploads/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves webauth options for authentication ceremony
 * Retrieves webauth options for authentication ceremony
 */
export const postWebauthLoginOptions = <ThrowOnError extends boolean = false>(options?: Options<PostWebauthLoginOptionsData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<PostWebauthLoginOptionsResponse, PostWebauthLoginOptionsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/webauth/login/options',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Handles webauth login result
 * Handles webauth login result
 */
export const postWebauthLoginResult = <ThrowOnError extends boolean = false>(options?: Options<PostWebauthLoginResultData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<PostWebauthLoginResultResponse, PostWebauthLoginResultError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/webauth/login/result',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves webauth options for registration ceremony
 * Retrieves webauth options for registration ceremony
 */
export const postWebauthRegisterOptions = <ThrowOnError extends boolean = false>(options?: Options<PostWebauthRegisterOptionsData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<PostWebauthRegisterOptionsResponse, PostWebauthRegisterOptionsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/webauth/register/options',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Handles webauth register result
 * Handles webauth register result
 */
export const postWebauthRegisterResult = <ThrowOnError extends boolean = false>(options?: Options<PostWebauthRegisterResultData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<PostWebauthRegisterResultResponse, PostWebauthRegisterResultError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/webauth/register/result',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Removes the WebauthPasskey resource.
 * Removes the WebauthPasskey resource.
 */
export const apiWebauthPasskeysIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiWebauthPasskeysIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiWebauthPasskeysIdDeleteResponse, ApiWebauthPasskeysIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/webauth_passkeys/{id}',
    ...options
  })
}

/**
 * Replaces the WebauthPasskey resource.
 * Replaces the WebauthPasskey resource.
 */
export const apiWebauthPasskeysIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiWebauthPasskeysIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiWebauthPasskeysIdPutResponse, ApiWebauthPasskeysIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/webauth_passkeys/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a WebauthPasskeyCollection resource.
 * Retrieves a WebauthPasskeyCollection resource.
 */
export const apiWebauthPasskeysEmployeeGet = <ThrowOnError extends boolean = false>(options: Options<ApiWebauthPasskeysEmployeeGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiWebauthPasskeysEmployeeGetResponse, ApiWebauthPasskeysEmployeeGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/webauth_passkeys/{employee}',
    ...options
  })
}

/**
 * Retrieves the collection of Whistleblow resources.
 * Retrieves the collection of Whistleblow resources.
 */
export const apiWhistleblowsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiWhistleblowsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiWhistleblowsGetCollectionResponse, ApiWhistleblowsGetCollectionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/whistleblows',
    ...options
  })
}

/**
 * Creates a Whistleblow resource.
 * Creates a Whistleblow resource.
 */
export const apiWhistleblowsPost = <ThrowOnError extends boolean = false>(options: Options<ApiWhistleblowsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiWhistleblowsPostResponse, ApiWhistleblowsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/whistleblows',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a Whistleblow resource.
 * Retrieves a Whistleblow resource.
 */
export const apiWhistleblowsIdAccessCodeGet = <ThrowOnError extends boolean = false>(options: Options<ApiWhistleblowsIdAccessCodeGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiWhistleblowsIdAccessCodeGetResponse, ApiWhistleblowsIdAccessCodeGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/whistleblows/{id}/{accessCode}',
    ...options
  })
}

/**
 * Creates a WhistleblowMessage resource.
 * Creates a WhistleblowMessage resource.
 */
export const apiWhistleblowMessagesPost = <ThrowOnError extends boolean = false>(options: Options<ApiWhistleblowMessagesPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiWhistleblowMessagesPostResponse, ApiWhistleblowMessagesPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/whistleblow_messages',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves an Employee resource for current user.
 * Retrieves an Employee resource for current user.
 */
export const whoami = <ThrowOnError extends boolean = false>(options?: Options<WhoamiData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<WhoamiResponse, WhoamiError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/whoami',
    ...options
  })
}

/**
 * Retrieves the collection of WorktimeTrackingDay resources.
 * Retrieves the collection of WorktimeTrackingDay resources.
 */
export const apiWorktimeTrackingDaysGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiWorktimeTrackingDaysGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiWorktimeTrackingDaysGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/worktime_tracking_days',
    ...options
  })
}

/**
 * Creates a WorktimeTrackingDay resource.
 * Creates a WorktimeTrackingDay resource.
 */
export const apiWorktimeTrackingDaysPost = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingDaysPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiWorktimeTrackingDaysPostResponse, ApiWorktimeTrackingDaysPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_days',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the WorktimeTrackingDay resource.
 * Removes the WorktimeTrackingDay resource.
 */
export const apiWorktimeTrackingDaysIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingDaysIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiWorktimeTrackingDaysIdDeleteResponse, ApiWorktimeTrackingDaysIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_days/{id}',
    ...options
  })
}

/**
 * Retrieves a WorktimeTrackingDay resource.
 * Retrieves a WorktimeTrackingDay resource.
 */
export const apiWorktimeTrackingDaysIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingDaysIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiWorktimeTrackingDaysIdGetResponse, ApiWorktimeTrackingDaysIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_days/{id}',
    ...options
  })
}

/**
 * Replaces the WorktimeTrackingDay resource.
 * Replaces the WorktimeTrackingDay resource.
 */
export const apiWorktimeTrackingDaysIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingDaysIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiWorktimeTrackingDaysIdPutResponse, ApiWorktimeTrackingDaysIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_days/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves the collection of WorktimeTrackingDayVersion resources.
 * Retrieves the collection of WorktimeTrackingDayVersion resources.
 */
export const apiWorktimeTrackingDayVersionsGetCollection = <ThrowOnError extends boolean = false>(options?: Options<ApiWorktimeTrackingDayVersionsGetCollectionData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiWorktimeTrackingDayVersionsGetCollectionResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/api/worktime_tracking_day_versions',
    ...options
  })
}

/**
 * Creates a WorktimeTrackingDayVersion resource.
 * Creates a WorktimeTrackingDayVersion resource.
 */
export const apiWorktimeTrackingDayVersionsPost = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingDayVersionsPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiWorktimeTrackingDayVersionsPostResponse, ApiWorktimeTrackingDayVersionsPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_day_versions',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Removes the WorktimeTrackingDayVersion resource.
 * Removes the WorktimeTrackingDayVersion resource.
 */
export const apiWorktimeTrackingDayVersionsIdDelete = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingDayVersionsIdDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<ApiWorktimeTrackingDayVersionsIdDeleteResponse, ApiWorktimeTrackingDayVersionsIdDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_day_versions/{id}',
    ...options
  })
}

/**
 * Retrieves a WorktimeTrackingDayVersion resource.
 * Retrieves a WorktimeTrackingDayVersion resource.
 */
export const apiWorktimeTrackingDayVersionsIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingDayVersionsIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiWorktimeTrackingDayVersionsIdGetResponse, ApiWorktimeTrackingDayVersionsIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_day_versions/{id}',
    ...options
  })
}

/**
 * Replaces the WorktimeTrackingDayVersion resource.
 * Replaces the WorktimeTrackingDayVersion resource.
 */
export const apiWorktimeTrackingDayVersionsIdPut = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingDayVersionsIdPutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<ApiWorktimeTrackingDayVersionsIdPutResponse, ApiWorktimeTrackingDayVersionsIdPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_day_versions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Creates a WorktimeTrackingEntryProposal resource.
 * Creates a WorktimeTrackingEntryProposal resource.
 */
export const apiWorktimetrackingentryproposalPost = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimetrackingentryproposalPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiWorktimetrackingentryproposalPostResponse, ApiWorktimetrackingentryproposalPostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktimetrackingentryproposal',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a WorktimeTrackingRelevance resource.
 * Retrieves a WorktimeTrackingRelevance resource.
 */
export const apiWorktimeTrackingRelevancesEmployeeDateGet = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingRelevancesEmployeeDateGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiWorktimeTrackingRelevancesEmployeeDateGetResponse, ApiWorktimeTrackingRelevancesEmployeeDateGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_relevances/{employee}/{date}',
    ...options
  })
}

/**
 * Retrieves a WorktimeTracking summary response for current employee
 * Retrieves a WorktimeTrackingSummary resource.
 */
export const apiWorktimeTrackingSummaryGet = <ThrowOnError extends boolean = false>(options?: Options<ApiWorktimeTrackingSummaryGetData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ApiWorktimeTrackingSummaryGetResponse, ApiWorktimeTrackingSummaryGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_summary',
    ...options
  })
}

/**
 * Invokes an action change
 * Creates a WorktimeTrackingSummary resource.
 */
export const apiWorktimeTrackingSummaryPost = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingSummaryPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ApiWorktimeTrackingSummaryPostResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_summary',
    ...options,
    headers: {
      'Content-Type': 'application/ld+json',
      ...options?.headers
    }
  })
}

/**
 * Retrieves a WorktimeTracking summary response for given employee
 * Retrieves a WorktimeTrackingSummary resource.
 */
export const apiWorktimeTrackingSummaryEmpIdGet = <ThrowOnError extends boolean = false>(options: Options<ApiWorktimeTrackingSummaryEmpIdGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ApiWorktimeTrackingSummaryEmpIdGetResponse, ApiWorktimeTrackingSummaryEmpIdGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/api/worktime_tracking_summary/{empId}',
    ...options
  })
}
